import { useState, useEffect, useRef } from "react";

const API_URL = "https://saglikbul-api.alponat.workers.dev";

const sendMail = async (endpoint, data) => {
  try {
    await fetch(`${API_URL}/api/mail/${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  } catch (e) { console.log("Mail gonderilemedi:", e); }
};

const INITIAL_DOCTORS = [
  { id: 1, name: "Dr. Ayşe Yılmaz", title: "Prof. Dr.", specialty: "Kardiyoloji", sub: "Kalp ve Damar Cerrahisi", city: "İstanbul", district: "Kadıköy", hospital: "Acıbadem Hastanesi", experience: 15, rating: 4.9, reviews: 342, price: 800, availableToday: true, nextSlot: "14:30", avatar: "AY", color: "#e74c3c", tags: ["EKG", "Anjiyografi", "Kalp Yetmezliği"], bio: "15 yıllık deneyimiyle kalp hastalıkları tedavisinde uzman.", status: "approved", consultType: "both", email: "ayse@mail.com", phone: "0532 111 22 33" },
  { id: 2, name: "Dr. Mehmet Kaya", title: "Doç. Dr.", specialty: "Nöroloji", sub: "Beyin ve Sinir Hastalıkları", city: "Ankara", district: "Çankaya", hospital: "Hacettepe Üniversitesi", experience: 22, rating: 4.8, reviews: 518, price: 900, availableToday: true, nextSlot: "10:00", avatar: "MK", color: "#3498db", tags: ["Migren", "Epilepsi", "MS"], bio: "Nörobilim alanında uluslararası yayınları bulunan deneyimli hekim.", status: "approved", consultType: "yuzYuze", email: "mehmet@mail.com", phone: "0533 222 33 44" },
  { id: 3, name: "Dr. Fatma Demir", title: "Uzm. Dr.", specialty: "Pediatri", sub: "Çocuk Sağlığı ve Hastalıkları", city: "İzmir", district: "Karşıyaka", hospital: "Ege Üniversitesi", experience: 10, rating: 4.9, reviews: 267, price: 600, availableToday: false, nextSlot: "Yarın 09:00", avatar: "FD", color: "#2ecc71", tags: ["Aşılama", "Büyüme Takibi", "Alerji"], bio: "Çocukların sağlıklı büyümesi için özenle çalışan bir pediatrist.", status: "approved", consultType: "both", email: "fatma@mail.com", phone: "0534 333 44 55" },
  { id: 4, name: "Dr. Ali Özkan", title: "Prof. Dr.", specialty: "Ortopedi", sub: "Kemik ve Eklem Cerrahisi", city: "İstanbul", district: "Şişli", hospital: "Florence Nightingale", experience: 18, rating: 4.7, reviews: 410, price: 850, availableToday: true, nextSlot: "16:00", avatar: "AÖ", color: "#e67e22", tags: ["Diz Protezi", "Omurga", "Spor Yaralanması"], bio: "Spor cerrahisi ve eklem protezinde uzmanlaşmış cerrah.", status: "approved", consultType: "yuzYuze", email: "ali@mail.com", phone: "0535 444 55 66" },
  { id: 5, name: "Dr. Zeynep Arslan", title: "Uzm. Dr.", specialty: "Dermatoloji", sub: "Cilt Hastalıkları", city: "Antalya", district: "Muratpaşa", hospital: "Memorial Hastanesi", experience: 8, rating: 4.8, reviews: 189, price: 550, availableToday: true, nextSlot: "11:30", avatar: "ZA", color: "#9b59b6", tags: ["Akne", "Lazer", "Cilt Kanseri"], bio: "Estetik dermatoloji ve cilt bakımı konusunda uzman hekim.", status: "approved", consultType: "online", email: "zeynep@mail.com", phone: "0536 555 66 77" },
  { id: 6, name: "Dr. Hasan Çelik", title: "Prof. Dr.", specialty: "Göz Hastalıkları", sub: "Oftalmoloji", city: "İstanbul", district: "Beşiktaş", hospital: "Dünyagöz Hastanesi", experience: 25, rating: 4.9, reviews: 623, price: 750, availableToday: false, nextSlot: "Yarın 10:30", avatar: "HÇ", color: "#1abc9c", tags: ["Katarakt", "Lazer", "Glokom"], bio: "25 yılı aşkın tecrübesiyle göz cerrahisinde öncü isim.", status: "approved", consultType: "yuzYuze", email: "hasan@mail.com", phone: "0537 666 77 88" },
  { id: 7, name: "Dr. Elif Şahin", title: "Doç. Dr.", specialty: "Psikiyatri", sub: "Ruh Sağlığı", city: "Ankara", district: "Kızılay", hospital: "Gazi Üniversitesi", experience: 12, rating: 4.7, reviews: 298, price: 700, availableToday: true, nextSlot: "13:00", avatar: "EŞ", color: "#f39c12", tags: ["Depresyon", "Anksiyete", "DEHB"], bio: "Bilişsel davranışçı terapi ile ruh sağlığı tedavisinde uzman.", status: "approved", consultType: "both", email: "elif@mail.com", phone: "0538 777 88 99" },
  { id: 8, name: "Dr. Burak Aydın", title: "Uzm. Dr.", specialty: "Dahiliye", sub: "İç Hastalıkları", city: "Bursa", district: "Nilüfer", hospital: "Uludağ Üniversitesi", experience: 14, rating: 4.6, reviews: 201, price: 500, availableToday: true, nextSlot: "15:00", avatar: "BA", color: "#34495e", tags: ["Diyabet", "Tiroid", "Check-up"], bio: "İç hastalıkları ve metabolik hastalıklar konusunda deneyimli.", status: "approved", consultType: "both", email: "burak@mail.com", phone: "0539 888 99 00" },
  { id: 9, name: "Dr. Selin Yıldız", title: "Uzm. Dr.", specialty: "Kadın Doğum", sub: "Jinekoloji ve Obstetrik", city: "İstanbul", district: "Ataşehir", hospital: "Medical Park", experience: 11, rating: 4.8, reviews: 356, price: 700, availableToday: true, nextSlot: "09:30", avatar: "SY", color: "#e91e63", tags: ["Gebelik Takibi", "Ultrason", "Tüp Bebek"], bio: "Gebelik sürecinde yanınızda olan güvenilir bir uzman.", status: "approved", consultType: "online", email: "selin@mail.com", phone: "0540 999 00 11" },
  { id: 10, name: "Dr. Can Türkmen", title: "Prof. Dr.", specialty: "Üroloji", sub: "Üriner Sistem Hastalıkları", city: "İzmir", district: "Bornova", hospital: "Dokuz Eylül Üniversitesi", experience: 20, rating: 4.7, reviews: 445, price: 800, availableToday: false, nextSlot: "Yarın 14:00", avatar: "CT", color: "#00897b", tags: ["Böbrek Taşı", "Prostat", "Robotik Cerrahi"], bio: "Minimal invaziv cerrahi tekniklerinde uzmanlaşmış ürolog.", status: "approved", consultType: "yuzYuze", email: "can@mail.com", phone: "0541 000 11 22" },
];

const ALL_SPECIALTIES = [
  "Kardiyoloji", "Nöroloji", "Pediatri", "Ortopedi", "Dermatoloji",
  "Göz Hastalıkları", "Psikiyatri", "Dahiliye", "Kadın Doğum", "Üroloji",
  "Genel Cerrahi", "KBB", "Göğüs Hastalıkları", "Endokrinoloji", "Fizik Tedavi",
  "Beyin Cerrahisi", "Plastik Cerrahi", "Onkoloji", "Gastroenteroloji", "Hematoloji"
];

const ALL_CITIES = ["İstanbul", "Ankara", "İzmir", "Bursa", "Antalya", "Adana", "Konya", "Gaziantep", "Kayseri", "Mersin", "Eskişehir", "Samsun", "Trabzon", "Diyarbakır"];

const AVATAR_COLORS = ["#e74c3c", "#3498db", "#2ecc71", "#e67e22", "#9b59b6", "#1abc9c", "#f39c12", "#34495e", "#e91e63", "#00897b", "#607d8b", "#795548"];

const TIME_SLOTS = [
  { time: "09:00", period: "Sabah" }, { time: "09:30", period: "Sabah" },
  { time: "10:00", period: "Sabah" }, { time: "10:30", period: "Sabah" },
  { time: "11:00", period: "Sabah" }, { time: "11:30", period: "Sabah" },
  { time: "13:00", period: "Öğleden Sonra" }, { time: "13:30", period: "Öğleden Sonra" },
  { time: "14:00", period: "Öğleden Sonra" }, { time: "14:30", period: "Öğleden Sonra" },
  { time: "15:00", period: "Öğleden Sonra" }, { time: "15:30", period: "Öğleden Sonra" },
  { time: "16:00", period: "Öğleden Sonra" }, { time: "16:30", period: "Öğleden Sonra" },
];

const DATES = (() => {
  const dates = [];
  const today = new Date();
  const days = ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"];
  const months = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];
  for (let i = 0; i < 7; i++) {
    const d = new Date(today);
    d.setDate(d.getDate() + i);
    dates.push({
      date: d,
      day: d.getDate(),
      dayName: i === 0 ? "Bugün" : i === 1 ? "Yarın" : days[d.getDay()],
      month: months[d.getMonth()],
      isWeekend: d.getDay() === 0 || d.getDay() === 6,
    });
  }
  return dates;
})();

function StarRating({ rating }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 2 }}>
      {[1, 2, 3, 4, 5].map(i => (
        <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill={i <= Math.round(rating) ? "#f59e0b" : "none"} stroke="#f59e0b" strokeWidth="2">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
    </span>
  );
}

export default function DoctorFinder() {
  const [page, setPage] = useState("home");
  const [doctors, setDoctors] = useState(INITIAL_DOCTORS);
  const [search, setSearch] = useState("");
  const [selSpecialty, setSelSpecialty] = useState("");
  const [selCity, setSelCity] = useState("");
  const [sortBy, setSortBy] = useState("rating");
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [selDate, setSelDate] = useState(0);
  const [selTime, setSelTime] = useState(null);
  const [bookingStep, setBookingStep] = useState(0);
  const [patientInfo, setPatientInfo] = useState({ name: "", phone: "", email: "", note: "" });
  const [bookingDone, setBookingDone] = useState(false);
  const [favorited, setFavorited] = useState(new Set());
  const [consultMode, setConsultMode] = useState("all"); // "all", "yuzYuze", "online"
  const [selBranch, setSelBranch] = useState("");

  // Doctor panel states
  const [doctorLoggedIn, setDoctorLoggedIn] = useState(false);
  const [doctorAccount, setDoctorAccount] = useState(null);
  const [doctorAuthMode, setDoctorAuthMode] = useState("login");
  const [doctorLoginForm, setDoctorLoginForm] = useState({ email: "", password: "" });
  const [doctorForm, setDoctorForm] = useState({
    name: "", title: "Uzm. Dr.", specialty: "", sub: "", city: "", district: "",
    hospital: "", experience: "", price: "", bio: "", tags: "", phone: "", email: "", password: "", consultType: "both"
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [doctorAvailSlots, setDoctorAvailSlots] = useState({});

  // Appointments state
  const [appointments, setAppointments] = useState([
    { id: "a1", doctorId: 1, doctorName: "Dr. Ayşe Yılmaz", specialty: "Kardiyoloji", patient: "Ahmet Yilmaz", phone: "0532 999 88 77", email: "ahmet@mail.com", date: "Bugun, 7 Nis", time: "14:30", status: "confirmed", note: "Gogus agrisi", price: 800, createdAt: "2026-04-07T08:00:00" },
    { id: "a2", doctorId: 2, doctorName: "Dr. Mehmet Kaya", specialty: "Nöroloji", patient: "Fatma Kara", phone: "0533 888 77 66", email: "fatma.k@mail.com", date: "Yarin, 8 Nis", time: "10:00", status: "confirmed", note: "Kronik migren", price: 900, createdAt: "2026-04-06T15:30:00" },
    { id: "a3", doctorId: 5, doctorName: "Dr. Zeynep Arslan", specialty: "Dermatoloji", patient: "Emre Demir", phone: "0534 777 66 55", email: "emre@mail.com", date: "9 Nis", time: "11:30", status: "pending", note: "Cilt dokuntusi", price: 550, createdAt: "2026-04-07T10:00:00" },
    { id: "a4", doctorId: 9, doctorName: "Dr. Selin Yıldız", specialty: "Kadın Doğum", patient: "Ayse Cetin", phone: "0535 666 55 44", email: "ayse.c@mail.com", date: "10 Nis", time: "09:30", status: "confirmed", note: "Gebelik kontrolu", price: 700, createdAt: "2026-04-06T12:00:00" },
    { id: "a5", doctorId: 7, doctorName: "Dr. Elif Şahin", specialty: "Psikiyatri", patient: "Murat Aydin", phone: "0536 555 44 33", email: "murat@mail.com", date: "Bugun, 7 Nis", time: "13:00", status: "cancelled", note: "Anksiyete", price: 700, createdAt: "2026-04-05T09:00:00" },
  ]);
  const [apptFilter, setApptFilter] = useState("all");

  // Blog state
  const [blogPosts, setBlogPosts] = useState([
    { id: "b1", title: "Kış Aylarında Grip ve Soğuk Algınlığından Korunma Yolları", author: "Dr. Mehmet Kaya", authorId: 2, specialty: "Nöroloji", date: "2026-04-05", category: "Mevsimsel", summary: "Kış aylarında bağışıklık sistemini güçlendirmek için beslenme, uyku düzeni ve hijyen kurallarına dikkat etmek büyük önem taşır. El yıkama, C vitamini ve düzenli egzersiz en etkili koruma yöntemleridir.", content: "Kış aylarında grip ve soğuk algınlığı vakaları artış gösterir. Bağışıklık sistemini güçlü tutmak için dengeli beslenme, yeterli uyku ve düzenli egzersiz şarttır. C vitamini açısından zengin meyveler tüketin. Elleri sık sık yıkayın. Kapalı ortamlarda uzun süre kalmaktan kaçının." },
    { id: "b2", title: "Diyabet Hastalarında Beslenme Rehberi", author: "Dr. Burak Aydın", authorId: 8, specialty: "Dahiliye", date: "2026-04-03", category: "Beslenme", summary: "Tip 2 diyabet hastalarında kan şekeri kontrolü için doğru beslenme hayati önem taşır. Glisemik indeksi düşük gıdalar tercih edilmeli, öğün atlanmamalıdır.", content: "Diyabet hastaları için beslenme, tedavinin temel taşlarından biridir. Beyaz ekmek yerine tam tahıllı ekmek, şekerli içecekler yerine su tercih edilmelidir. Porsiyon kontrolü önemlidir. Günde 3 ana öğün ve 2-3 ara öğün şeklinde beslenilmelidir." },
    { id: "b3", title: "Çocuklarda Aşı Takvimi: Nelere Dikkat Etmeli?", author: "Dr. Fatma Demir", authorId: 3, specialty: "Pediatri", date: "2026-04-01", category: "Çocuk Sağlığı", summary: "Çocukluk çağı aşıları, birçok ölümcül hastalığa karşı en etkili koruma yöntemidir. Aşı takvimini takip etmek ebeveynlerin en önemli sorumluluklarından biridir.", content: "Doğumdan itibaren uygulanan aşılar çocuğunuzu birçok ciddi hastalıktan korur. Hepatit B, BCG, DaBT-İPA-Hib, KPA, KKK, suçiçeği gibi aşılar düzenli olarak yapılmalıdır. Aşı sonrası hafif ateş ve ağrı normal olabilir." },
    { id: "b4", title: "Migren Ağrısıyla Başa Çıkma Yöntemleri", author: "Dr. Mehmet Kaya", authorId: 2, specialty: "Nöroloji", date: "2026-03-28", category: "Nöroloji", summary: "Migren, dünya genelinde milyonlarca insanı etkileyen ciddi bir nörolojik rahatsızlıktır. Tetikleyicileri tanımak ve uygun tedavi yöntemlerini bilmek yaşam kalitesini artırır.", content: "Migren ağrısını tetikleyen faktörler: stres, uykusuzluk, bazı yiyecekler ve hormonal değişiklikler. Karanlık ve sessiz bir odada dinlenmek, alnına soğuk kompres uygulamak rahatlama sağlar. Kronik migrende önleyici tedavi uygulanabilir." },
    { id: "b5", title: "Cilt Bakımında Doğru Bilinen Yanlışlar", author: "Dr. Zeynep Arslan", authorId: 5, specialty: "Dermatoloji", date: "2026-03-25", category: "Dermatoloji", summary: "Cilt bakımında doğru bilinen birçok yanlış uygulama, cildinize fayda yerine zarar verebilir. Uzman görüşü almadan yapılan bakımlar ciddi sorunlara yol açabilir.", content: "Limon suyu sürmek, sık sık peeling yapmak ve güneş kremini sadece yazın kullanmak en yaygın yanlışlardandır. Güneş kremi her mevsim kullanılmalıdır. Cilt tipinize uygun ürünler seçin. Fazla temizlik cildin doğal bariyerini bozar." },
    { id: "b6", title: "Kalp Sağlığı İçin 10 Altın Kural", author: "Dr. Ayşe Yılmaz", authorId: 1, specialty: "Kardiyoloji", date: "2026-03-22", category: "Kardiyoloji", summary: "Kalp hastalıkları dünyada en yaygın ölüm nedenlerinden biridir. Basit yaşam tarzı değişiklikleri ile kalp sağlığınızı korumak mümkündür.", content: "1. Düzenli egzersiz yapın 2. Tuzu azaltın 3. Sigarayı bırakın 4. Sağlıklı kilonuzu koruyun 5. Stresi yönetin 6. Tansiyonunuzu takip edin 7. Kolesterolünüzü kontrol ettirin 8. Omega-3 açısından zengin beslenin 9. Alkol tüketimini sınırlayın 10. Düzenli check-up yaptırın." },
  ]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [blogCategory, setBlogCategory] = useState("all");

  // Patient panel states
  const [patientLoggedIn, setPatientLoggedIn] = useState(false);
  const [patientAccount, setPatientAccount] = useState(null);
  const [patientRegForm, setPatientRegForm] = useState({ name: "", email: "", phone: "", password: "", tc: "", birthYear: "", gender: "", city: "", bloodType: "" });
  const [patientLoginForm, setPatientLoginForm] = useState({ email: "", password: "" });
  const [patientAuthMode, setPatientAuthMode] = useState("login"); // "login" or "register"
  const [registeredPatients, setRegisteredPatients] = useState([
    { id: "p1", name: "Ahmet Yilmaz", email: "ahmet@mail.com", phone: "0532 999 88 77", password: "123456", tc: "12345678901", birthYear: "1985", gender: "Erkek", city: "İstanbul", bloodType: "A Rh+" },
  ]);

  // Review state
  const [doctorReviews, setDoctorReviews] = useState([
    { id: "r1", doctorId: 1, patientName: "Ahmet Yilmaz", rating: 5, comment: "Cok ilgili ve bilgili bir doktor. Kesinlikle tavsiye ederim.", date: "2026-04-06" },
    { id: "r2", doctorId: 2, patientName: "Fatma Kara", rating: 5, comment: "Migren tedavimde buyuk ilerleme saglandi. Tesekkurler.", date: "2026-04-05" },
    { id: "r3", doctorId: 1, patientName: "Zehra Demir", rating: 4, comment: "Guler yuzlu, randevu saatine uyuyor.", date: "2026-03-28" },
    { id: "r4", doctorId: 5, patientName: "Can Ozturk", rating: 5, comment: "Cilt problemim tamamen cozuldu.", date: "2026-03-25" },
  ]);
  const [reviewForm, setReviewForm] = useState({ rating: 0, comment: "" });

  // Admin states
  const [adminLoggedIn, setAdminLoggedIn] = useState(false);
  const [adminPass, setAdminPass] = useState("");
  const [mobileMenu, setMobileMenu] = useState(false);

  // localStorage: Load
  useEffect(() => {
    try {
      const d = localStorage.getItem("saglikbul_doctors"); if (d) setDoctors(JSON.parse(d));
      const a = localStorage.getItem("saglikbul_appointments"); if (a) setAppointments(JSON.parse(a));
      const p = localStorage.getItem("saglikbul_patients"); if (p) setRegisteredPatients(JSON.parse(p));
      const r = localStorage.getItem("saglikbul_reviews"); if (r) setDoctorReviews(JSON.parse(r));
      const av = localStorage.getItem("saglikbul_avail"); if (av) setDoctorAvailSlots(JSON.parse(av));
    } catch(e) {}
  }, []);

  // localStorage: Save
  useEffect(() => { try { localStorage.setItem("saglikbul_doctors", JSON.stringify(doctors)); } catch(e) {} }, [doctors]);
  useEffect(() => { try { localStorage.setItem("saglikbul_appointments", JSON.stringify(appointments)); } catch(e) {} }, [appointments]);
  useEffect(() => { try { localStorage.setItem("saglikbul_patients", JSON.stringify(registeredPatients)); } catch(e) {} }, [registeredPatients]);
  useEffect(() => { try { localStorage.setItem("saglikbul_reviews", JSON.stringify(doctorReviews)); } catch(e) {} }, [doctorReviews]);
  useEffect(() => { try { localStorage.setItem("saglikbul_avail", JSON.stringify(doctorAvailSlots)); } catch(e) {} }, [doctorAvailSlots]);

  const approvedDoctors = doctors.filter(d => d.status === "approved");
  const pendingDoctors = doctors.filter(d => d.status === "pending");

  const SPECIALTIES = [...new Set(approvedDoctors.map(d => d.specialty))];
  const CITIES = [...new Set(approvedDoctors.map(d => d.city))];

  const filtered = approvedDoctors.filter(d => {
    const q = search.toLowerCase();
    const matchSearch = !q || d.name.toLowerCase().includes(q) || d.specialty.toLowerCase().includes(q) || d.tags.some(t => t.toLowerCase().includes(q)) || d.hospital.toLowerCase().includes(q);
    const matchSpec = !selSpecialty || d.specialty === selSpecialty;
    const matchBranch = !selBranch || d.specialty === selBranch;
    const matchCity = !selCity || d.city === selCity;
    const matchConsult = consultMode === "all" || d.consultType === consultMode || d.consultType === "both";
    return matchSearch && matchSpec && matchBranch && matchCity && matchConsult;
  }).sort((a, b) => {
    if (sortBy === "rating") return b.rating - a.rating;
    if (sortBy === "price_low") return a.price - b.price;
    if (sortBy === "price_high") return b.price - a.price;
    if (sortBy === "experience") return b.experience - a.experience;
    return 0;
  });

  const openDoctor = (d) => { setSelectedDoctor(d); setPage("detail"); setSelDate(0); setSelTime(null); setBookingStep(0); setBookingDone(false); };
  const goHome = () => { setPage("home"); setSelectedDoctor(null); };
  const toggleFav = (id) => setFavorited(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });

  // Doktorun dolu slotlarini hesapla (onceki randevulardan)
  const getUnavailSlots = (docId) => {
    return new Set(appointments.filter(a => a.doctorId === docId && a.status !== "cancelled" && a.status !== "rejected").map(a => a.time));
  };

  // Doktorun musait oldugu slotlari getir
  const getDoctorAvailTimes = (docId) => {
    const keys = Object.keys(doctorAvailSlots).filter(k => k.startsWith(`${docId}-time-`) && doctorAvailSlots[k]);
    return keys.map(k => k.replace(`${docId}-time-`, ""));
  };

  // Randevu tipi state (yuzYuze veya online)
  const [bookingType, setBookingType] = useState("yuzYuze");

  const generateMeetLink = (doctorName, patientName) => {
    const room = `saglikbul-${doctorName.replace(/[^a-zA-Z]/g, "").toLowerCase()}-${Date.now()}`;
    return `https://meet.jit.si/${room}`;
  };

  const confirmBooking = () => {
    if (!patientInfo.name || !patientInfo.phone) return;
    const isOnline = bookingType === "online";
    const meetLink = isOnline ? generateMeetLink(selectedDoctor.name, patientInfo.name) : null;
    const newAppt = {
      id: `a${Date.now()}`,
      doctorId: selectedDoctor.id,
      doctorName: selectedDoctor.name,
      specialty: selectedDoctor.specialty,
      patient: patientInfo.name,
      phone: patientInfo.phone,
      email: patientInfo.email,
      date: `${DATES[selDate]?.dayName}, ${DATES[selDate]?.day} ${DATES[selDate]?.month}`,
      time: selTime,
      status: "pending",
      note: patientInfo.note,
      price: selectedDoctor.price,
      createdAt: new Date().toISOString(),
      type: bookingType,
      meetLink: meetLink,
      hospital: selectedDoctor.hospital,
      city: selectedDoctor.city,
      district: selectedDoctor.district,
    };
    setAppointments(prev => [newAppt, ...prev]);
    setBookingDone(true);
    if (patientInfo.email) {
      sendMail("appointment-created", {
        patientEmail: patientInfo.email, doctorName: selectedDoctor.name,
        specialty: selectedDoctor.specialty, date: newAppt.date, time: selTime,
        type: bookingType, hospital: selectedDoctor.hospital,
        city: selectedDoctor.city, price: selectedDoctor.price,
      });
    }
  };

  const updateApptStatus = (id, newStatus) => {
    const appt = appointments.find(a => a.id === id);
    setAppointments(prev => prev.map(a => a.id === id ? { ...a, status: newStatus } : a));
    if (appt && appt.email) {
      if (newStatus === "confirmed") {
        sendMail("appointment-confirmed", {
          patientEmail: appt.email, doctorName: appt.doctorName,
          date: appt.date, time: appt.time, type: appt.type || "yuzYuze",
          meetLink: appt.meetLink, hospital: appt.hospital, city: appt.city,
        });
      } else if (newStatus === "cancelled") {
        sendMail("appointment-cancelled", {
          patientEmail: appt.email, doctorName: appt.doctorName,
          date: appt.date, time: appt.time,
        });
      }
    }
  };

  const submitDoctorForm = () => {
    const f = doctorForm;
    if (!f.name || !f.specialty || !f.city || !f.hospital || !f.experience || !f.price || !f.bio || !f.phone || !f.email) return;

    const initials = f.name.replace("Dr. ", "").split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
    const newDoctor = {
      id: Date.now(),
      name: f.name.startsWith("Dr.") ? f.name : `Dr. ${f.name}`,
      title: f.title,
      specialty: f.specialty,
      sub: f.sub || f.specialty,
      city: f.city,
      district: f.district || "",
      hospital: f.hospital,
      experience: parseInt(f.experience),
      rating: 0,
      reviews: 0,
      price: parseInt(f.price),
      availableToday: false,
      nextSlot: "-",
      avatar: initials,
      color: AVATAR_COLORS[Math.floor(Math.random() * AVATAR_COLORS.length)],
      tags: f.tags ? f.tags.split(",").map(t => t.trim()).filter(Boolean) : [],
      bio: f.bio,
      phone: f.phone,
      email: f.email,
      consultType: f.consultType,
      status: "pending",
      appliedAt: new Date().toISOString(),
    };
    setDoctors(prev => [...prev, newDoctor]);
    setFormSubmitted(true);
    sendMail("doctor-apply", { email: f.email, name: newDoctor.name });
  };

  const approveDoctor = (id) => {
    const doc = doctors.find(d => d.id === id);
    setDoctors(prev => prev.map(d => d.id === id ? { ...d, status: "approved", availableToday: true, nextSlot: "10:00" } : d));
    if (doc && doc.email) sendMail("doctor-approved", { email: doc.email, name: doc.name });
  };

  const rejectDoctor = (id) => {
    setDoctors(prev => prev.map(d => d.id === id ? { ...d, status: "rejected" } : d));
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        :root {
          --bg: #faf8f5; --bg2: #f3efe9; --card: #ffffff; --border: #e8e2d9;
          --accent: #1a7a5c; --accent-light: #e8f5ef; --accent-hover: #15634a;
          --text: #2c2520; --text2: #6b5e52; --text3: #9e9288;
          --warm: #d4a574; --warm-light: #fdf0e4; --red: #c0392b; --gold: #f59e0b;
        }
        body { background: var(--bg); }
        ::selection { background: var(--accent-light); color: var(--accent); }
        ::-webkit-scrollbar { width: 6px; } ::-webkit-scrollbar-track { background: transparent; } ::-webkit-scrollbar-thumb { background: var(--border); border-radius: 3px; }
        input, select, textarea { outline: none; font-family: 'Outfit', sans-serif; }
        input::placeholder, textarea::placeholder { color: var(--text3); }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        @keyframes float { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
        @keyframes checkPop { 0% { transform: scale(0); } 50% { transform: scale(1.2); } 100% { transform: scale(1); } }
        .doc-card { background: var(--card); border: 1px solid var(--border); border-radius: 18px; padding: 22px; cursor: pointer; transition: all 0.35s cubic-bezier(.4,0,.2,1); position: relative; overflow: hidden; }
        .doc-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; background: var(--accent); transform: scaleX(0); transition: transform 0.35s ease; transform-origin: left; }
        .doc-card:hover { transform: translateY(-4px); box-shadow: 0 12px 40px rgba(44,37,32,0.1); border-color: var(--accent); }
        .doc-card:hover::before { transform: scaleX(1); }
        .chip { display: inline-flex; align-items: center; padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 500; border: 1px solid var(--border); color: var(--text2); background: var(--bg); transition: all 0.2s; cursor: pointer; }
        .chip:hover { border-color: var(--accent); color: var(--accent); background: var(--accent-light); }
        .btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 12px 24px; border-radius: 12px; font-weight: 600; font-size: 14px; cursor: pointer; transition: all 0.25s ease; border: none; font-family: 'Outfit', sans-serif; }
        .btn-accent { background: var(--accent); color: #fff; }
        .btn-accent:hover { background: var(--accent-hover); transform: translateY(-1px); box-shadow: 0 6px 20px rgba(26,122,92,0.25); }
        .btn-outline { background: transparent; color: var(--accent); border: 1.5px solid var(--accent); }
        .btn-outline:hover { background: var(--accent-light); }
        .btn-ghost { background: transparent; color: var(--text2); border: 1px solid var(--border); }
        .btn-ghost:hover { border-color: var(--text2); color: var(--text); }
        .btn-danger { background: var(--red); color: #fff; }
        .btn-danger:hover { background: #a93226; transform: translateY(-1px); }
        .field { width: 100%; padding: 12px 16px; border: 1.5px solid var(--border); border-radius: 12px; font-size: 14px; color: var(--text); background: var(--card); transition: border-color 0.2s; }
        .field:focus { border-color: var(--accent); }
        .time-slot { padding: 10px 16px; border-radius: 10px; border: 1.5px solid var(--border); background: var(--card); cursor: pointer; font-size: 14px; font-weight: 500; color: var(--text); transition: all 0.2s; text-align: center; font-family: 'Outfit', sans-serif; }
        .time-slot:hover:not(.unavail):not(.selected) { border-color: var(--accent); color: var(--accent); background: var(--accent-light); }
        .time-slot.selected { border-color: var(--accent); background: var(--accent); color: #fff; }
        .time-slot.unavail { opacity: 0.35; cursor: not-allowed; text-decoration: line-through; }
        .date-chip { padding: 10px 6px; border-radius: 14px; border: 1.5px solid var(--border); background: var(--card); cursor: pointer; text-align: center; transition: all 0.2s; min-width: 68px; font-family: 'Outfit', sans-serif; }
        .date-chip:hover:not(.date-sel) { border-color: var(--accent); }
        .date-sel { border-color: var(--accent); background: var(--accent); color: #fff !important; }
        .date-sel * { color: #fff !important; }
        .fav-btn { position: absolute; top: 16px; right: 16px; background: var(--card); border: 1px solid var(--border); width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; z-index: 2; font-size: 16px; }
        .fav-btn:hover { transform: scale(1.1); box-shadow: 0 2px 10px rgba(0,0,0,0.1); }
        .status-badge { display: inline-flex; align-items: center; gap: 6px; padding: 4px 12px; border-radius: 20px; font-size: 12px; font-weight: 600; }
        .status-pending { background: #fff3cd; color: #856404; }
        .status-approved { background: var(--accent-light); color: var(--accent); }
        .status-rejected { background: #f8d7da; color: var(--red); }
        .mobile-menu-btn { display: none; background: none; border: 1px solid var(--border); border-radius: 8px; padding: 6px 10px; cursor: pointer; font-size: 18px; }
        .mobile-overlay { display: none; }
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
          .mobile-overlay { display: block; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); z-index: 200; }
          .mobile-nav { position: fixed; top: 0; right: 0; bottom: 0; width: 280px; background: var(--card); z-index: 201; padding: 24px; display: flex; flex-direction: column; gap: 8px; box-shadow: -4px 0 20px rgba(0,0,0,0.1); }
          .mobile-nav a, .mobile-nav span, .mobile-nav button { display: block; width: 100%; text-align: left; padding: 12px 16px; border-radius: 10px; }
        }
        @media (max-width: 900px) {
          .hero-title { font-size: 28px !important; }
          .hero-search { flex-direction: column !important; border-radius: 14px !important; }
          .hero-search > * { border-right: none !important; border-bottom: 1px solid var(--border); min-width: auto !important; }
          .hero-search > *:last-child { border-bottom: none; }
          .hero-search input, .hero-search select { padding: 14px 16px !important; }
          .hero-search .btn { border-radius: 0 0 12px 12px !important; }
          .grid-4 { grid-template-columns: repeat(2, 1fr) !important; }
          .grid-3 { grid-template-columns: 1fr !important; }
          .grid-2 { grid-template-columns: 1fr !important; }
          .doc-detail-grid { grid-template-columns: 1fr !important; }
          .doc-card { flex-direction: column !important; }
          .doc-card > div:last-child { align-items: flex-start !important; text-align: left !important; flex-direction: row !important; gap: 12px !important; flex-wrap: wrap; }
          .footer-grid { grid-template-columns: 1fr !important; gap: 20px !important; }
          .stat-grid-4 { grid-template-columns: repeat(2, 1fr) !important; }
          .profile-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .dash-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 480px) {
          .hero-title { font-size: 24px !important; }
          .stat-grid-4 { grid-template-columns: 1fr 1fr !important; }
          .grid-4 { grid-template-columns: 1fr !important; }
          .profile-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>

      <div style={{ fontFamily: "'Outfit', sans-serif", color: "var(--text)", minHeight: "100vh", background: "var(--bg)" }}>

        {/* Header */}
        <header style={{
          background: "var(--card)", borderBottom: "1px solid var(--border)",
          position: "sticky", top: 0, zIndex: 100, backdropFilter: "blur(12px)",
          backgroundColor: "rgba(255,255,255,0.92)"
        }}>
          <div style={{ maxWidth: 1200, margin: "0 auto", padding: "14px 28px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }} onClick={goHome}>
              <svg width="38" height="38" viewBox="0 0 40 40" fill="none">
                <rect width="40" height="40" rx="12" fill="url(#logoGrad)"/>
                <path d="M20 8C14.5 8 10 12.5 10 18c0 3.5 1.8 6.6 4.5 8.4L13 31l4.5-2.5c.8.2 1.6.3 2.5.3 5.5 0 10-4.5 10-10S25.5 8 20 8z" fill="rgba(255,255,255,0.2)"/>
                <path d="M17 18h6M20 15v6" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/>
                <path d="M20 28c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8z" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" fill="none"/>
                <defs><linearGradient id="logoGrad" x1="0" y1="0" x2="40" y2="40"><stop stopColor="#1a7a5c"/><stop offset="1" stopColor="#2ecc71"/></linearGradient></defs>
              </svg>
              <div>
                <span style={{ fontFamily: "'Lora', serif", fontSize: 20, fontWeight: 700, color: "var(--text)" }}>SaglikBul</span>
                <span style={{ fontSize: 10, color: "var(--text3)", display: "block", marginTop: -2, letterSpacing: 1.5, textTransform: "uppercase" }}>Doktor & Randevu</span>
              </div>
            </div>

            {/* Mobile Menu Button */}
            <button className="mobile-menu-btn" onClick={() => setMobileMenu(!mobileMenu)}>&#9776;</button>

            {/* Mobile Menu Overlay */}
            {mobileMenu && <>
              <div className="mobile-overlay" onClick={() => setMobileMenu(false)} />
              <div className="mobile-nav">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                  <span style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 700 }}>Menu</span>
                  <button onClick={() => setMobileMenu(false)} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer" }}>&#10005;</button>
                </div>
                {[
                  { label: "Ana Sayfa", action: goHome },
                  { label: "Uzmanliklar", action: () => setPage("specialties") },
                  { label: "Randevular", action: () => setPage("appointments") },
                  { label: "Blog", action: () => setPage("blog") },
                  { label: "Hasta Paneli", action: () => { setPage("patient-panel"); if (!patientLoggedIn) { setPatientAuthMode("login"); setPatientLoginForm({ email: "", password: "" }); } } },
                  { label: "Doktor Paneli", action: () => { setPage("doctor-panel"); if (!doctorLoggedIn) { setDoctorAuthMode("login"); setDoctorLoginForm({ email: "", password: "" }); } } },
                  { label: "Yonetim", action: () => { setPage("admin"); setAdminLoggedIn(false); setAdminPass(""); } },
                ].map((item, i) => (
                  <button key={i} className="btn btn-ghost" onClick={() => { item.action(); setMobileMenu(false); }}
                    style={{ justifyContent: "flex-start", width: "100%" }}>{item.label}</button>
                ))}
              </div>
            </>}

            {/* Desktop Nav */}
            <nav className="desktop-nav" style={{ display: "flex", alignItems: "center", gap: 16 }}>
              {[
                { label: "Ana Sayfa", action: goHome },
                { label: "Uzmanliklar", action: () => setPage("specialties") },
                { label: "Randevular", action: () => setPage("appointments") },
                { label: "Blog", action: () => setPage("blog") },
              ].map((item, i) => (
                <span key={i} onClick={item.action} style={{ fontSize: 14, fontWeight: 500, color: "var(--text2)", cursor: "pointer", transition: "color 0.2s", padding: "4px 0" }}
                  onMouseEnter={e => e.target.style.color = "var(--accent)"} onMouseLeave={e => e.target.style.color = "var(--text2)"}>
                  {item.label}
                </span>
              ))}
              <button className="btn btn-ghost" style={{ padding: "8px 16px", fontSize: 13 }}
                onClick={() => { setPage("patient-panel"); if (!patientLoggedIn) { setPatientAuthMode("login"); setPatientLoginForm({ email: "", password: "" }); } }}>
                Hasta Paneli
              </button>
              <button className="btn btn-outline" style={{ padding: "8px 16px", fontSize: 13 }}
                onClick={() => { setPage("doctor-panel"); if (!doctorLoggedIn) { setDoctorAuthMode("login"); setDoctorLoginForm({ email: "", password: "" }); } }}>
                Doktor Paneli
              </button>
              <button className="btn btn-accent" style={{ padding: "8px 16px", fontSize: 13 }}
                onClick={() => { setPage("admin"); setAdminLoggedIn(false); setAdminPass(""); }}>
                Yonetim
              </button>
            </nav>
          </div>
        </header>

        {/* ==================== HOME PAGE ==================== */}
        {page === "home" && (
          <>
            {/* Hero */}
            <section style={{
              background: "linear-gradient(170deg, var(--accent-light) 0%, var(--bg) 50%, var(--warm-light) 100%)",
              padding: "64px 28px 48px", textAlign: "center", position: "relative", overflow: "hidden"
            }}>
              <div style={{ position: "absolute", top: -60, right: -60, width: 300, height: 300, borderRadius: "50%", background: "rgba(26,122,92,0.05)", filter: "blur(60px)" }} />
              <div style={{ position: "absolute", bottom: -40, left: -40, width: 200, height: 200, borderRadius: "50%", background: "rgba(212,165,116,0.08)", filter: "blur(40px)" }} />

              <div style={{ maxWidth: 740, margin: "0 auto", position: "relative" }}>
                <h1 style={{
                  fontFamily: "'Lora', serif", fontSize: 44, fontWeight: 700,
                  lineHeight: 1.2, marginBottom: 16, color: "var(--text)",
                  animation: "fadeUp 0.6s ease"
                }}>
                  Doktorunuzu Bulun,<br />
                  <span style={{ color: "var(--accent)" }}>Randevunuzu Alin</span>
                </h1>
                <p style={{ fontSize: 17, color: "var(--text2)", lineHeight: 1.6, marginBottom: 28, animation: "fadeUp 0.6s ease 0.1s both" }}>
                  Turkiye'nin en iyi doktorlarina ulasin. Uzmanlik alani, konum ve musaitlik durumuna gore arayin, aninda online randevu alin.
                </p>

                {/* Yuz Yuze / Online Toggle */}
                <div style={{
                  display: "flex", gap: 0, background: "var(--bg2)", borderRadius: 14, padding: 4,
                  maxWidth: 360, margin: "0 auto 24px", animation: "fadeUp 0.6s ease 0.15s both"
                }}>
                  {[
                    { key: "all", label: "Tumunu Goster", icon: "&#128101;" },
                    { key: "yuzYuze", label: "Yuz Yuze", icon: "&#127973;" },
                    { key: "online", label: "Online", icon: "&#128187;" },
                  ].map(m => (
                    <button key={m.key} onClick={() => setConsultMode(m.key)}
                      style={{
                        flex: 1, padding: "10px 8px", borderRadius: 10, border: "none",
                        background: consultMode === m.key ? "var(--card)" : "transparent",
                        color: consultMode === m.key ? "var(--accent)" : "var(--text3)",
                        fontWeight: consultMode === m.key ? 600 : 500, fontSize: 13,
                        cursor: "pointer", transition: "all 0.2s",
                        boxShadow: consultMode === m.key ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
                        fontFamily: "'Outfit', sans-serif"
                      }}
                      dangerouslySetInnerHTML={{ __html: `${m.icon} ${m.label}` }} />
                  ))}
                </div>

                {/* Search Bar - Brans + Doktor Ara + Sehir Sec + Ara */}
                <div style={{
                  display: "flex", gap: 0, background: "var(--card)", borderRadius: 16,
                  border: "1.5px solid var(--border)", overflow: "hidden",
                  boxShadow: "0 8px 30px rgba(44,37,32,0.08)", maxWidth: 740, margin: "0 auto",
                  animation: "fadeUp 0.6s ease 0.2s both"
                }}>
                  {/* Uzman Brans */}
                  <select value={selBranch} onChange={e => setSelBranch(e.target.value)}
                    style={{ border: "none", background: "transparent", padding: "0 14px", fontSize: 13, color: "var(--text2)", cursor: "pointer", minWidth: 150, borderRight: "1px solid var(--border)" }}>
                    <option value="">Uzman Brans</option>
                    {ALL_SPECIALTIES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>

                  {/* Doktor Ara */}
                  <div style={{ flex: 1, display: "flex", alignItems: "center", padding: "0 14px", gap: 8, borderRight: "1px solid var(--border)" }}>
                    <span style={{ fontSize: 16, opacity: 0.5 }}>&#128269;</span>
                    <input value={search} onChange={e => setSearch(e.target.value)}
                      placeholder="Doktor ara..."
                      style={{ border: "none", background: "transparent", fontSize: 14, color: "var(--text)", padding: "16px 0", width: "100%" }} />
                  </div>

                  {/* Sehir Sec */}
                  <select value={selCity} onChange={e => setSelCity(e.target.value)}
                    style={{ border: "none", background: "transparent", padding: "0 14px", fontSize: 13, color: "var(--text2)", cursor: "pointer", minWidth: 130, borderRight: "1px solid var(--border)" }}>
                    <option value="">Sehir Sec</option>
                    {ALL_CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>

                  {/* Ara Butonu */}
                  <button className="btn btn-accent" style={{ borderRadius: 0, padding: "16px 28px", fontSize: 15 }}>Ara</button>
                </div>
              </div>
            </section>

            {/* Specialty Quick Filters */}
            <section style={{ maxWidth: 1200, margin: "0 auto", padding: "32px 28px 8px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: "var(--text3)", marginRight: 4 }}>Populer:</span>
                {SPECIALTIES.map(s => (
                  <button key={s} className="chip" onClick={() => setSelSpecialty(selSpecialty === s ? "" : s)}
                    style={selSpecialty === s ? { borderColor: "var(--accent)", color: "var(--accent)", background: "var(--accent-light)" } : {}}>
                    {s}
                  </button>
                ))}
              </div>
            </section>

            {/* Sort & Results */}
            <section style={{ maxWidth: 1200, margin: "0 auto", padding: "20px 28px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
                <p style={{ fontSize: 14, color: "var(--text2)" }}>
                  <strong style={{ color: "var(--text)" }}>{filtered.length}</strong> doktor bulundu
                  {selSpecialty && <> · <span style={{ color: "var(--accent)" }}>{selSpecialty}</span></>}
                </p>
                <select value={sortBy} onChange={e => setSortBy(e.target.value)}
                  style={{ border: "1px solid var(--border)", borderRadius: 10, padding: "8px 14px", fontSize: 13, color: "var(--text2)", background: "var(--card)", cursor: "pointer" }}>
                  <option value="rating">En Yuksek Puan</option>
                  <option value="experience">En Tecrubeli</option>
                  <option value="price_low">Fiyat: Dusukten Yuksege</option>
                  <option value="price_high">Fiyat: Yuksekten Dusuge</option>
                </select>
              </div>

              {/* Doctor List */}
              <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                {filtered.map((d, i) => (
                  <div key={d.id} className="doc-card" onClick={() => openDoctor(d)}
                    style={{ animation: `fadeUp 0.4s ease ${i * 0.05}s both`, display: "flex", gap: 20, alignItems: "flex-start" }}>

                    <button className="fav-btn" onClick={e => { e.stopPropagation(); toggleFav(d.id); }}>
                      {favorited.has(d.id) ? "\u2764\uFE0F" : "\uD83E\uDD0D"}
                    </button>

                    {/* Avatar */}
                    <div style={{
                      width: 80, height: 80, borderRadius: 18, flexShrink: 0,
                      background: `linear-gradient(135deg, ${d.color}20, ${d.color}08)`,
                      border: `2px solid ${d.color}25`,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 22, fontWeight: 700, color: d.color
                    }}>{d.avatar}</div>

                    {/* Info */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4, flexWrap: "wrap" }}>
                        <h3 style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 600 }}>{d.name}</h3>
                        <span style={{ fontSize: 12, color: "var(--text3)", fontWeight: 500 }}>{d.title}</span>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                        <p style={{ fontSize: 14, color: "var(--accent)", fontWeight: 500 }}>{d.specialty} · {d.sub}</p>
                        {d.consultType === "online" && <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 6, background: "#e8f4fd", color: "#2980b9", fontWeight: 600 }}>&#128187; Online</span>}
                        {d.consultType === "yuzYuze" && <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 6, background: "#fef3e2", color: "#e67e22", fontWeight: 600 }}>&#127973; Yuz Yuze</span>}
                        {d.consultType === "both" && <><span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 6, background: "#e8f4fd", color: "#2980b9", fontWeight: 600 }}>&#128187; Online</span><span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 6, background: "#fef3e2", color: "#e67e22", fontWeight: 600 }}>&#127973; Yuz Yuze</span></>}
                      </div>
                      <p style={{ fontSize: 13, color: "var(--text3)", marginBottom: 10 }}>&#127973; {d.hospital} · &#128205; {d.city}{d.district ? `, ${d.district}` : ""} · &#128197; {d.experience} yil tecrube</p>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                        {d.tags.map(t => (
                          <span key={t} style={{ fontSize: 11, padding: "3px 10px", borderRadius: 6, background: "var(--bg2)", color: "var(--text2)", fontWeight: 500 }}>{t}</span>
                        ))}
                      </div>
                    </div>

                    {/* Right Side */}
                    <div style={{ textAlign: "right", flexShrink: 0, minWidth: 140, display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <StarRating rating={d.rating} />
                        <span style={{ fontWeight: 700, fontSize: 15 }}>{d.rating}</span>
                        <span style={{ fontSize: 12, color: "var(--text3)" }}>({d.reviews})</span>
                      </div>
                      <div style={{ fontSize: 22, fontWeight: 700, color: "var(--text)" }}>
                        &#8378;{d.price}
                        <span style={{ fontSize: 12, fontWeight: 400, color: "var(--text3)" }}> /muayene</span>
                      </div>
                      {d.availableToday ? (
                        <span style={{
                          display: "inline-flex", alignItems: "center", gap: 5,
                          padding: "5px 12px", borderRadius: 8, fontSize: 12, fontWeight: 600,
                          background: "var(--accent-light)", color: "var(--accent)"
                        }}>
                          <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--accent)", animation: "float 2s ease infinite" }} />
                          Bugun Musait · {d.nextSlot}
                        </span>
                      ) : (
                        <span style={{ padding: "5px 12px", borderRadius: 8, fontSize: 12, fontWeight: 500, background: "var(--bg2)", color: "var(--text3)" }}>
                          {d.nextSlot}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {filtered.length === 0 && (
                <div style={{ textAlign: "center", padding: 80 }}>
                  <div style={{ fontSize: 56, marginBottom: 16 }}>&#129658;</div>
                  <h3 style={{ fontFamily: "'Lora', serif", fontSize: 22, marginBottom: 8 }}>Sonuc bulunamadi</h3>
                  <p style={{ color: "var(--text3)" }}>Arama kriterlerinizi degistirmeyi deneyin</p>
                </div>
              )}
            </section>

            {/* Guncel Saglik Bilgileri */}
            <section style={{ maxWidth: 1200, margin: "0 auto", padding: "48px 28px 20px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24 }}>
                <div>
                  <h2 style={{ fontFamily: "'Lora', serif", fontSize: 26, fontWeight: 700, marginBottom: 4 }}>
                    Saglik <span style={{ color: "var(--accent)" }}>Rehberi</span>
                  </h2>
                  <p style={{ color: "var(--text3)", fontSize: 14 }}>Doktorlarimizdan guncel saglik bilgileri</p>
                </div>
                <button className="btn btn-outline" style={{ fontSize: 13, padding: "8px 18px" }} onClick={() => setPage("blog")}>
                  Tum Yazilar &#8594;
                </button>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 18 }}>
                {blogPosts.slice(0, 3).map((post, i) => {
                  const catColors = { "Mevsimsel": "#3498db", "Beslenme": "#2ecc71", "Çocuk Sağlığı": "#e74c3c", "Nöroloji": "#9b59b6", "Dermatoloji": "#e67e22", "Kardiyoloji": "#c0392b" };
                  return (
                    <div key={post.id} onClick={() => { setSelectedPost(post); setPage("blog"); }}
                      style={{
                        background: "var(--card)", border: "1px solid var(--border)", borderRadius: 18,
                        padding: 24, cursor: "pointer", transition: "all 0.3s cubic-bezier(.4,0,.2,1)",
                        animation: `fadeUp 0.4s ease ${i * 0.08}s both`,
                        display: "flex", flexDirection: "column"
                      }}
                      onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 40px rgba(44,37,32,0.1)"; }}
                      onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}>
                      <span style={{ fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 6, background: `${catColors[post.category] || "var(--accent)"}15`, color: catColors[post.category] || "var(--accent)", alignSelf: "flex-start", marginBottom: 12 }}>
                        {post.category}
                      </span>
                      <h4 style={{ fontFamily: "'Lora', serif", fontSize: 16, fontWeight: 600, marginBottom: 10, lineHeight: 1.4, color: "var(--text)" }}>{post.title}</h4>
                      <p style={{ fontSize: 13, color: "var(--text3)", lineHeight: 1.6, marginBottom: 16, flex: 1 }}>{post.summary.slice(0, 120)}...</p>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 12, color: "var(--text3)" }}>
                        <span style={{ fontWeight: 500 }}>{post.author}</span>
                        <span>{new Date(post.date).toLocaleDateString("tr-TR", { day: "numeric", month: "short" })}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>

            {/* Sik Gorulen Hastaliklar */}
            <section style={{ maxWidth: 1200, margin: "0 auto", padding: "40px 28px 20px" }}>
              <h2 style={{ fontFamily: "'Lora', serif", fontSize: 26, fontWeight: 700, marginBottom: 6, textAlign: "center" }}>
                Sik Gorulen <span style={{ color: "var(--accent)" }}>Hastaliklar</span>
              </h2>
              <p style={{ color: "var(--text3)", fontSize: 14, textAlign: "center", marginBottom: 28 }}>Bilgi amacli hastalik ozetleri</p>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14 }}>
                {[
                  { name: "Hipertansiyon", icon: "&#128147;", desc: "Yuksek tansiyon, kalp ve damar sagligini tehdit eden sessiz bir hastaliktir. Duzenli olcum ve yasam tarzi degisiklikleri ile kontrol altina alinabilir.", branch: "Kardiyoloji" },
                  { name: "Tip 2 Diyabet", icon: "&#129656;", desc: "Kan sekeri regulasyonunun bozuldugu metabolik bir hastaliktir. Dogru beslenme ve egzersiz tedavinin temelini olusturur.", branch: "Dahiliye" },
                  { name: "Migren", icon: "&#129504;", desc: "Tekrarlayan, siddetti bas agrisi ataklariyla karakterize norolojik bir rahatsizliktir. Tetikleyicilerden kacinmak onemlidir.", branch: "Nöroloji" },
                  { name: "Astim", icon: "&#129697;", desc: "Hava yollarinin daralmasina bagli nefes darligi, oksuruk ve hiriltili solunum ile kendini gosteren kronik bir akciger hastaligidir.", branch: "Göğüs Hastalıkları" },
                  { name: "Depresyon", icon: "&#128546;", desc: "Surekli uzuntu, ilgi kaybi ve enerji dusukluguyle karakterize ruhsal bir saglik sorunudur. Profesyonel destek cok onemlidir.", branch: "Psikiyatri" },
                  { name: "Bel Fitigi", icon: "&#129460;", desc: "Omurlar arasindaki disklerin yipranmasi sonucu olusan, bel ve bacak agrisina neden olan ortopedik bir sorundur.", branch: "Ortopedi" },
                  { name: "Reflü", icon: "&#129424;", desc: "Mide asidinin yemek borusuna geri kacmasiyla olusan yanma hissidir. Beslenme aliskanliklari tedavide anahtar roldedir.", branch: "Gastroenteroloji" },
                  { name: "Alerji", icon: "&#129319;", desc: "Bagisiklik sisteminin zararsiz maddelere karsi asiri tepki vermesidir. Hapsirik, kasinti ve dokuntuye neden olabilir.", branch: "Dermatoloji" },
                ].map((h, i) => (
                  <div key={h.name} style={{
                    background: "var(--card)", border: "1px solid var(--border)", borderRadius: 16,
                    padding: 20, animation: `fadeUp 0.4s ease ${i * 0.04}s both`,
                    transition: "all 0.3s ease", cursor: "default"
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 8px 24px rgba(44,37,32,0.08)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}>
                    <div style={{ fontSize: 28, marginBottom: 8 }} dangerouslySetInnerHTML={{ __html: h.icon }} />
                    <h4 style={{ fontFamily: "'Lora', serif", fontSize: 15, fontWeight: 600, marginBottom: 6 }}>{h.name}</h4>
                    <p style={{ fontSize: 12, color: "var(--text3)", lineHeight: 1.5, marginBottom: 10 }}>{h.desc}</p>
                    <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 6, background: "var(--accent-light)", color: "var(--accent)", fontWeight: 500, cursor: "pointer" }}
                      onClick={() => { setSelBranch(h.branch); setPage("home"); }}>
                      {h.branch}
                    </span>
                  </div>
                ))}
              </div>
            </section>
          </>
        )}

        {/* ==================== DETAIL + BOOKING PAGE ==================== */}
        {page === "detail" && selectedDoctor && (
          <div style={{ maxWidth: 1200, margin: "0 auto", padding: "28px", animation: "fadeUp 0.4s ease" }}>
            <button className="btn btn-ghost" onClick={goHome} style={{ marginBottom: 24, fontSize: 13, padding: "8px 16px" }}>
              &#8592; Doktor Listesine Don
            </button>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 400px", gap: 28 }}>
              {/* Left - Doctor Info */}
              <div>
                <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 20, padding: 28, marginBottom: 20 }}>
                  <div style={{ display: "flex", gap: 22, alignItems: "flex-start" }}>
                    <div style={{
                      width: 100, height: 100, borderRadius: 22, flexShrink: 0,
                      background: `linear-gradient(135deg, ${selectedDoctor.color}25, ${selectedDoctor.color}08)`,
                      border: `2px solid ${selectedDoctor.color}30`,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 30, fontWeight: 700, color: selectedDoctor.color
                    }}>{selectedDoctor.avatar}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
                        <h1 style={{ fontFamily: "'Lora', serif", fontSize: 26, fontWeight: 700 }}>{selectedDoctor.name}</h1>
                        <span style={{ fontSize: 12, padding: "3px 10px", borderRadius: 6, background: "var(--accent-light)", color: "var(--accent)", fontWeight: 600 }}>{selectedDoctor.title}</span>
                      </div>
                      <p style={{ color: "var(--accent)", fontSize: 16, fontWeight: 500, marginBottom: 8 }}>{selectedDoctor.specialty} — {selectedDoctor.sub}</p>
                      <p style={{ color: "var(--text3)", fontSize: 14, lineHeight: 1.6, marginBottom: 12 }}>{selectedDoctor.bio}</p>
                      <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
                        {[
                          { icon: "&#127973;", text: selectedDoctor.hospital },
                          { icon: "&#128205;", text: `${selectedDoctor.city}${selectedDoctor.district ? ", " + selectedDoctor.district : ""}` },
                          { icon: "&#128197;", text: `${selectedDoctor.experience} Yil Tecrube` },
                        ].map((item, i) => (
                          <span key={i} style={{ fontSize: 13, color: "var(--text2)", display: "flex", alignItems: "center", gap: 6 }}
                            dangerouslySetInnerHTML={{ __html: `<span>${item.icon}</span> ${item.text}` }} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Stats */}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14, marginBottom: 20 }}>
                  {[
                    { label: "Hasta Degerlendirmesi", value: selectedDoctor.rating, sub: `${selectedDoctor.reviews} yorum`, icon: "\u2B50" },
                    { label: "Muayene Ucreti", value: `\u20BA${selectedDoctor.price}`, sub: "Muayene basina", icon: "\uD83D\uDCB3" },
                    { label: "Tecrube", value: `${selectedDoctor.experience} Yil`, sub: "Aktif pratik", icon: "\uD83C\uDF93" },
                  ].map((s, i) => (
                    <div key={i} style={{
                      background: "var(--card)", border: "1px solid var(--border)", borderRadius: 16,
                      padding: 20, textAlign: "center", animation: `fadeUp 0.4s ease ${i * 0.08}s both`
                    }}>
                      <div style={{ fontSize: 24, marginBottom: 8 }}>{s.icon}</div>
                      <div style={{ fontSize: 22, fontWeight: 700, color: "var(--text)", marginBottom: 2 }}>{s.value}</div>
                      <div style={{ fontSize: 12, color: "var(--text3)" }}>{s.sub}</div>
                      <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 4, fontWeight: 500 }}>{s.label}</div>
                    </div>
                  ))}
                </div>

                {/* Tags */}
                <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 16, padding: 22 }}>
                  <h3 style={{ fontFamily: "'Lora', serif", fontSize: 16, fontWeight: 600, marginBottom: 14 }}>Uzmanlik Alanlari</h3>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {selectedDoctor.tags.map(t => <span key={t} className="chip">{t}</span>)}
                  </div>
                </div>
              </div>

              {/* Right - Booking Panel */}
              <div>
                <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 20, padding: 26, position: "sticky", top: 80 }}>
                  {!bookingDone ? (
                    <>
                      <h3 style={{ fontFamily: "'Lora', serif", fontSize: 20, fontWeight: 600, marginBottom: 4 }}>Randevu Al</h3>
                      <p style={{ color: "var(--text3)", fontSize: 13, marginBottom: 16 }}>Randevu tipini secin, tarih ve saati belirleyin</p>

                      {/* Randevu Tipi Secimi */}
                      {(selectedDoctor.consultType === "both" || selectedDoctor.consultType === "online" || selectedDoctor.consultType === "yuzYuze") && (
                        <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
                          {(selectedDoctor.consultType === "yuzYuze" || selectedDoctor.consultType === "both") && (
                            <button onClick={() => setBookingType("yuzYuze")}
                              style={{
                                flex: 1, padding: "12px 10px", borderRadius: 12, border: `1.5px solid ${bookingType === "yuzYuze" ? "var(--accent)" : "var(--border)"}`,
                                background: bookingType === "yuzYuze" ? "var(--accent-light)" : "var(--card)",
                                color: bookingType === "yuzYuze" ? "var(--accent)" : "var(--text3)",
                                fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "'Outfit', sans-serif", textAlign: "center",
                                transition: "all 0.2s"
                              }}>
                              &#127973; Yuz Yuze
                              <div style={{ fontSize: 11, fontWeight: 400, marginTop: 2 }}>{selectedDoctor.hospital}</div>
                            </button>
                          )}
                          {(selectedDoctor.consultType === "online" || selectedDoctor.consultType === "both") && (
                            <button onClick={() => setBookingType("online")}
                              style={{
                                flex: 1, padding: "12px 10px", borderRadius: 12, border: `1.5px solid ${bookingType === "online" ? "#2980b9" : "var(--border)"}`,
                                background: bookingType === "online" ? "#e8f4fd" : "var(--card)",
                                color: bookingType === "online" ? "#2980b9" : "var(--text3)",
                                fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "'Outfit', sans-serif", textAlign: "center",
                                transition: "all 0.2s"
                              }}>
                              &#128187; Online Gorusme
                              <div style={{ fontSize: 11, fontWeight: 400, marginTop: 2 }}>Video gorusme ile</div>
                            </button>
                          )}
                        </div>
                      )}

                      <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
                        {["Tarih & Saat", "Bilgiler", "Onay"].map((step, i) => (
                          <div key={i} style={{ flex: 1, textAlign: "center" }}>
                            <div style={{
                              width: 28, height: 28, borderRadius: "50%", margin: "0 auto 6px",
                              display: "flex", alignItems: "center", justifyContent: "center",
                              fontSize: 12, fontWeight: 700,
                              background: bookingStep >= i ? "var(--accent)" : "var(--bg2)",
                              color: bookingStep >= i ? "#fff" : "var(--text3)",
                              transition: "all 0.3s ease"
                            }}>{i + 1}</div>
                            <div style={{ fontSize: 11, color: bookingStep >= i ? "var(--accent)" : "var(--text3)", fontWeight: 500 }}>{step}</div>
                          </div>
                        ))}
                      </div>

                      {bookingStep === 0 && (() => {
                        const docAvailTimes = getDoctorAvailTimes(selectedDoctor.id);
                        const bookedSlots = getUnavailSlots(selectedDoctor.id);
                        const hasAvailability = docAvailTimes.length > 0;
                        return (
                        <div style={{ animation: "fadeUp 0.3s ease" }}>
                          {!hasAvailability ? (
                            <div style={{ textAlign: "center", padding: 30, background: "var(--bg)", borderRadius: 14 }}>
                              <div style={{ fontSize: 40, marginBottom: 10 }}>&#128197;</div>
                              <h4 style={{ fontFamily: "'Lora', serif", fontSize: 16, marginBottom: 8 }}>Musaitlik Bilgisi Yok</h4>
                              <p style={{ color: "var(--text3)", fontSize: 13 }}>Bu doktor henuz musaitlik durumunu belirlemedi. Lutfen daha sonra tekrar kontrol edin.</p>
                            </div>
                          ) : (
                            <>
                              <label style={{ fontSize: 13, fontWeight: 600, color: "var(--text2)", display: "block", marginBottom: 10 }}>Tarih Secin</label>
                              <div style={{ display: "flex", gap: 8, marginBottom: 22, overflowX: "auto", paddingBottom: 4 }}>
                                {DATES.filter(d => !d.isWeekend).map((d, i) => (
                                  <div key={i} className={`date-chip ${selDate === i ? "date-sel" : ""}`} onClick={() => { setSelDate(i); setSelTime(null); }}>
                                    <div style={{ fontSize: 11, fontWeight: 500, color: selDate === i ? "#fff" : "var(--text3)", marginBottom: 2 }}>{d.dayName}</div>
                                    <div style={{ fontSize: 20, fontWeight: 700 }}>{d.day}</div>
                                    <div style={{ fontSize: 11, color: selDate === i ? "rgba(255,255,255,0.8)" : "var(--text3)" }}>{d.month}</div>
                                  </div>
                                ))}
                              </div>

                              <label style={{ fontSize: 13, fontWeight: 600, color: "var(--text2)", display: "block", marginBottom: 10 }}>Musait Saatler</label>
                              {["Sabah", "Öğleden Sonra"].map(period => {
                                const periodSlots = TIME_SLOTS.filter(s => s.period === period && docAvailTimes.includes(s.time));
                                if (periodSlots.length === 0) return null;
                                return (
                                <div key={period} style={{ marginBottom: 14 }}>
                                  <div style={{ fontSize: 11, color: "var(--text3)", fontWeight: 600, marginBottom: 8, textTransform: "uppercase", letterSpacing: 1 }}>{period}</div>
                                  <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8 }}>
                                    {periodSlots.map(s => {
                                      const isBooked = bookedSlots.has(s.time);
                                      return (
                                      <button key={s.time}
                                        className={`time-slot ${selTime === s.time ? "selected" : ""} ${isBooked ? "unavail" : ""}`}
                                        onClick={() => !isBooked && setSelTime(s.time)}>
                                        {s.time} {isBooked ? "(Dolu)" : ""}
                                      </button>
                                      );
                                    })}
                                  </div>
                                </div>
                                );
                              })}
                              <button className="btn btn-accent" style={{ width: "100%", marginTop: 10, padding: 14 }}
                                onClick={() => selTime && setBookingStep(1)} disabled={!selTime}>
                                Devam Et &#8594;
                              </button>
                            </>
                          )}
                        </div>
                        );
                      })()}

                      {bookingStep === 1 && (
                        <div style={{ animation: "fadeUp 0.3s ease" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                            <div>
                              <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Ad Soyad *</label>
                              <input className="field" placeholder="Adiniz Soyadiniz" value={patientInfo.name}
                                onChange={e => setPatientInfo(p => ({ ...p, name: e.target.value }))} />
                            </div>
                            <div>
                              <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Telefon *</label>
                              <input className="field" placeholder="0532 000 00 00" value={patientInfo.phone}
                                onChange={e => setPatientInfo(p => ({ ...p, phone: e.target.value }))} />
                            </div>
                            <div>
                              <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>E-posta</label>
                              <input className="field" placeholder="ornek@mail.com" value={patientInfo.email}
                                onChange={e => setPatientInfo(p => ({ ...p, email: e.target.value }))} />
                            </div>
                            <div>
                              <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Sikayet / Not</label>
                              <textarea className="field" rows={3} placeholder="Doktora iletmek istediginiz notlar..." value={patientInfo.note}
                                onChange={e => setPatientInfo(p => ({ ...p, note: e.target.value }))} style={{ resize: "vertical" }} />
                            </div>
                          </div>
                          <div style={{ display: "flex", gap: 10, marginTop: 18 }}>
                            <button className="btn btn-ghost" onClick={() => setBookingStep(0)} style={{ flex: 1 }}>&#8592; Geri</button>
                            <button className="btn btn-accent" onClick={() => (patientInfo.name && patientInfo.phone) && setBookingStep(2)} style={{ flex: 2 }}>Devam Et &#8594;</button>
                          </div>
                        </div>
                      )}

                      {bookingStep === 2 && (
                        <div style={{ animation: "fadeUp 0.3s ease" }}>
                          <div style={{ background: "var(--bg)", borderRadius: 14, padding: 18, marginBottom: 18 }}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text2)", marginBottom: 12 }}>Randevu Ozeti</div>
                            {[
                              { l: "Doktor", v: selectedDoctor.name },
                              { l: "Uzmanlik", v: selectedDoctor.specialty },
                              { l: "Randevu Tipi", v: bookingType === "online" ? "&#128187; Online Gorusme" : "&#127973; Yuz Yuze" },
                              { l: "Tarih", v: `${DATES[selDate]?.dayName}, ${DATES[selDate]?.day} ${DATES[selDate]?.month}` },
                              { l: "Saat", v: selTime },
                              { l: "Hasta", v: patientInfo.name },
                              { l: "Telefon", v: patientInfo.phone },
                              ...(bookingType === "yuzYuze" ? [{ l: "Adres", v: `${selectedDoctor.hospital}, ${selectedDoctor.city}${selectedDoctor.district ? " / " + selectedDoctor.district : ""}` }] : []),
                              { l: "Ucret", v: `\u20BA${selectedDoctor.price}` },
                            ].map((r, i) => (
                              <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: i < 7 ? "1px solid var(--border)" : "none" }}>
                                <span style={{ fontSize: 13, color: "var(--text3)" }}>{r.l}</span>
                                <span style={{ fontSize: 13, fontWeight: 600, color: "var(--text)" }} dangerouslySetInnerHTML={{ __html: r.v }} />
                              </div>
                            ))}
                            {bookingType === "online" && (
                              <div style={{ marginTop: 10, padding: 10, background: "#e8f4fd", borderRadius: 10, fontSize: 12, color: "#2980b9" }}>
                                &#128187; Randevunuz onaylandiktan sonra video gorusme linki olusturulacaktir.
                              </div>
                            )}
                            {bookingType === "yuzYuze" && (
                              <div style={{ marginTop: 10, padding: 10, background: "#fef3e2", borderRadius: 10, fontSize: 12, color: "#e67e22" }}>
                                &#127973; Randevu saatinden 15 dakika once klinige gelmeniz tavsiye edilir.
                              </div>
                            )}
                          </div>
                          <div style={{ display: "flex", gap: 10 }}>
                            <button className="btn btn-ghost" onClick={() => setBookingStep(1)} style={{ flex: 1 }}>&#8592; Geri</button>
                            <button className="btn btn-accent" onClick={confirmBooking} style={{ flex: 2 }}>&#10003; Randevuyu Onayla</button>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div style={{ textAlign: "center", padding: "20px 0", animation: "scaleIn 0.4s ease" }}>
                      <div style={{
                        width: 72, height: 72, borderRadius: "50%", background: "var(--accent-light)",
                        display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px",
                        fontSize: 34, animation: "checkPop 0.5s ease 0.2s both"
                      }}>&#10003;</div>
                      <h3 style={{ fontFamily: "'Lora', serif", fontSize: 22, fontWeight: 700, marginBottom: 6, color: "var(--accent)" }}>
                        Randevu Talebiniz Alindi!
                      </h3>
                      <p style={{ color: "var(--text3)", fontSize: 14, marginBottom: 20, lineHeight: 1.6 }}>
                        {selectedDoctor.name} ile<br />
                        <strong style={{ color: "var(--text)" }}>{DATES[selDate]?.dayName}, {DATES[selDate]?.day} {DATES[selDate]?.month} — {selTime}</strong><br />
                        tarihinde randevu talebiniz olusturuldu.
                      </p>
                      <div style={{ background: "#fff3cd", borderRadius: 12, padding: 14, marginBottom: 14, fontSize: 13, color: "#856404" }}>
                        &#9203; Randevunuz doktor onayi bekliyor. Onaylandiktan sonra bilgilendirileceksiniz.
                      </div>
                      {bookingType === "online" && (
                        <div style={{ background: "#e8f4fd", borderRadius: 12, padding: 14, marginBottom: 14, fontSize: 13, color: "#2980b9" }}>
                          &#128187; <strong>Online Gorusme:</strong> Doktor onayladiktan sonra video gorusme linkiniz aktif olacaktir. Hasta panelinizden erisebilirsiniz.
                        </div>
                      )}
                      {bookingType === "yuzYuze" && (
                        <div style={{ background: "#fef3e2", borderRadius: 12, padding: 14, marginBottom: 14, fontSize: 13, color: "#e67e22" }}>
                          &#127973; <strong>Yuz Yuze:</strong> {selectedDoctor.hospital}, {selectedDoctor.city}{selectedDoctor.district ? " / " + selectedDoctor.district : ""} adresine randevu saatinden 15 dk once geliniz.
                        </div>
                      )}
                      <button className="btn btn-accent" onClick={goHome} style={{ width: "100%" }}>Ana Sayfaya Don</button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ==================== DOKTOR PANELI ==================== */}
        {page === "doctor-panel" && (
          <div style={{ maxWidth: doctorLoggedIn ? 1100 : 520, margin: "0 auto", padding: "40px 28px", animation: "fadeUp 0.4s ease" }}>
            <button className="btn btn-ghost" onClick={goHome} style={{ marginBottom: 24, fontSize: 13, padding: "8px 16px" }}>
              &#8592; Ana Sayfaya Don
            </button>

            {!doctorLoggedIn ? (
              /* Doktor Login / Register */
              <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 24, padding: 40 }}>
                <div style={{ textAlign: "center", marginBottom: 28 }}>
                  <div style={{
                    width: 56, height: 56, borderRadius: 16, margin: "0 auto 16px",
                    background: "linear-gradient(135deg, var(--accent), #2ecc71)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 24, color: "#fff"
                  }}>&#9877;</div>
                  <h2 style={{ fontFamily: "'Lora', serif", fontSize: 24, fontWeight: 700, marginBottom: 8 }}>Doktor Paneli</h2>
                  <p style={{ color: "var(--text3)", fontSize: 14 }}>Randevularinizi yonetin, musaitlik durumunuzu guncelleyin</p>
                </div>

                <div style={{ display: "flex", gap: 0, background: "var(--bg2)", borderRadius: 12, padding: 4, marginBottom: 24 }}>
                  {[{ key: "login", label: "Giris Yap" }, { key: "register", label: "Kayit Ol" }].map(t => (
                    <button key={t.key} onClick={() => setDoctorAuthMode(t.key)}
                      style={{
                        flex: 1, padding: "10px", borderRadius: 8, border: "none",
                        background: doctorAuthMode === t.key ? "var(--card)" : "transparent",
                        color: doctorAuthMode === t.key ? "var(--accent)" : "var(--text3)",
                        fontWeight: 600, fontSize: 14, cursor: "pointer", transition: "all 0.2s",
                        boxShadow: doctorAuthMode === t.key ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
                        fontFamily: "'Outfit', sans-serif"
                      }}>{t.label}</button>
                  ))}
                </div>

                {doctorAuthMode === "login" ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>E-posta</label>
                      <input className="field" placeholder="doktor@mail.com" value={doctorLoginForm.email}
                        onChange={e => setDoctorLoginForm(f => ({ ...f, email: e.target.value }))} />
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Sifre</label>
                      <input className="field" type="password" placeholder="Sifreniz" value={doctorLoginForm.password}
                        onChange={e => setDoctorLoginForm(f => ({ ...f, password: e.target.value }))} />
                    </div>
                    <button className="btn btn-accent" style={{ width: "100%", padding: 14, marginTop: 8 }}
                      onClick={() => {
                        const found = approvedDoctors.find(d => d.email === doctorLoginForm.email);
                        if (found) { setDoctorAccount(found); setDoctorLoggedIn(true); }
                        else { alert("Kayitli doktor bulunamadi! Once kayit olun."); }
                      }}>
                      Giris Yap
                    </button>
                    <p style={{ fontSize: 12, color: "var(--text3)", textAlign: "center" }}>Demo: ayse@mail.com (mevcut doktorlar)</p>
                  </div>
                ) : (
                  /* Kayit / Basvuru Formu */
                  <div>
                    {!formSubmitted ? (
                      <div>

                {/* Kisisel Bilgiler */}
                <div style={{ marginBottom: 32 }}>
                  <h3 style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 600, marginBottom: 16, paddingBottom: 10, borderBottom: "1px solid var(--border)" }}>Kisisel Bilgiler</h3>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Ad Soyad *</label>
                      <input className="field" placeholder="Dr. Ad Soyad" value={doctorForm.name}
                        onChange={e => setDoctorForm(f => ({ ...f, name: e.target.value }))} />
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Unvan *</label>
                      <select className="field" value={doctorForm.title} onChange={e => setDoctorForm(f => ({ ...f, title: e.target.value }))}>
                        <option value="Uzm. Dr.">Uzm. Dr.</option>
                        <option value="Dr.">Dr.</option>
                        <option value="Doc. Dr.">Doc. Dr.</option>
                        <option value="Prof. Dr.">Prof. Dr.</option>
                      </select>
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Telefon *</label>
                      <input className="field" placeholder="0532 000 00 00" value={doctorForm.phone}
                        onChange={e => setDoctorForm(f => ({ ...f, phone: e.target.value }))} />
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>E-posta *</label>
                      <input className="field" placeholder="doktor@mail.com" value={doctorForm.email}
                        onChange={e => setDoctorForm(f => ({ ...f, email: e.target.value }))} />
                    </div>
                  </div>
                </div>

                {/* Mesleki Bilgiler */}
                <div style={{ marginBottom: 32 }}>
                  <h3 style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 600, marginBottom: 16, paddingBottom: 10, borderBottom: "1px solid var(--border)" }}>Mesleki Bilgiler</h3>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Uzmanlik Alani *</label>
                      <select className="field" value={doctorForm.specialty} onChange={e => setDoctorForm(f => ({ ...f, specialty: e.target.value }))}>
                        <option value="">Secin...</option>
                        {ALL_SPECIALTIES.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Alt Uzmanlik</label>
                      <input className="field" placeholder="Orn: Kalp ve Damar Cerrahisi" value={doctorForm.sub}
                        onChange={e => setDoctorForm(f => ({ ...f, sub: e.target.value }))} />
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Tecrube (Yil) *</label>
                      <input className="field" type="number" placeholder="15" value={doctorForm.experience}
                        onChange={e => setDoctorForm(f => ({ ...f, experience: e.target.value }))} />
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Muayene Ucreti (&#8378;) *</label>
                      <input className="field" type="number" placeholder="500" value={doctorForm.price}
                        onChange={e => setDoctorForm(f => ({ ...f, price: e.target.value }))} />
                    </div>
                    <div style={{ gridColumn: "1 / -1" }}>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 10 }}>Muayene Tipi *</label>
                      <div style={{ display: "flex", gap: 12 }}>
                        {[
                          { key: "yuzYuze", label: "Yuz Yuze", icon: "&#127973;" },
                          { key: "online", label: "Online", icon: "&#128187;" },
                          { key: "both", label: "Her Ikisi", icon: "&#127973;&#128187;" },
                        ].map(m => (
                          <button key={m.key} type="button" onClick={() => setDoctorForm(f => ({ ...f, consultType: m.key }))}
                            style={{
                              flex: 1, padding: "12px 10px", borderRadius: 12,
                              border: `1.5px solid ${doctorForm.consultType === m.key ? "var(--accent)" : "var(--border)"}`,
                              background: doctorForm.consultType === m.key ? "var(--accent-light)" : "var(--card)",
                              color: doctorForm.consultType === m.key ? "var(--accent)" : "var(--text2)",
                              fontWeight: 600, fontSize: 13, cursor: "pointer", transition: "all 0.2s",
                              fontFamily: "'Outfit', sans-serif", textAlign: "center"
                            }}
                            dangerouslySetInnerHTML={{ __html: `${m.icon}<br/>${m.label}` }} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Calisma Bilgileri */}
                <div style={{ marginBottom: 32 }}>
                  <h3 style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 600, marginBottom: 16, paddingBottom: 10, borderBottom: "1px solid var(--border)" }}>Calisma Bilgileri</h3>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Hastane / Klinik *</label>
                      <input className="field" placeholder="Hastane adi" value={doctorForm.hospital}
                        onChange={e => setDoctorForm(f => ({ ...f, hospital: e.target.value }))} />
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Sehir *</label>
                      <select className="field" value={doctorForm.city} onChange={e => setDoctorForm(f => ({ ...f, city: e.target.value }))}>
                        <option value="">Secin...</option>
                        {ALL_CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div style={{ gridColumn: "1 / -1" }}>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Ilce</label>
                      <input className="field" placeholder="Ilce adi" value={doctorForm.district}
                        onChange={e => setDoctorForm(f => ({ ...f, district: e.target.value }))} />
                    </div>
                  </div>
                </div>

                {/* Ek Bilgiler */}
                <div style={{ marginBottom: 32 }}>
                  <h3 style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 600, marginBottom: 16, paddingBottom: 10, borderBottom: "1px solid var(--border)" }}>Ek Bilgiler</h3>
                  <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Etiketler / Uzmanlik Alanlari</label>
                      <input className="field" placeholder="Virgul ile ayirin: EKG, Anjiyografi, Kalp Yetmezligi" value={doctorForm.tags}
                        onChange={e => setDoctorForm(f => ({ ...f, tags: e.target.value }))} />
                      <span style={{ fontSize: 11, color: "var(--text3)", marginTop: 4, display: "block" }}>Uzmanlik alanlarinizi virgul ile ayirarak yazin</span>
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Hakkinda / Biyografi *</label>
                      <textarea className="field" rows={4} placeholder="Kendinizi ve uzmanlik alanlarinizi kisa bir paragrafla anlatin..." value={doctorForm.bio}
                        onChange={e => setDoctorForm(f => ({ ...f, bio: e.target.value }))} style={{ resize: "vertical" }} />
                    </div>
                  </div>
                </div>

                <div style={{ background: "var(--bg)", borderRadius: 14, padding: 16, marginBottom: 24, display: "flex", alignItems: "flex-start", gap: 12 }}>
                  <span style={{ fontSize: 20, flexShrink: 0 }}>&#9432;</span>
                  <p style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.6 }}>
                    Basvurunuz yonetim ekibimiz tarafindan incelenecektir. Onay verildikten sonra profiliniz doktor listesinde gorunur olacak ve hastalar sizden randevu alabilecektir.
                  </p>
                </div>

                <button className="btn btn-accent" style={{ width: "100%", padding: 16, fontSize: 16 }} onClick={submitDoctorForm}>
                  Basvuruyu Gonder
                </button>
                      </div>
                    ) : (
                      <div style={{ textAlign: "center", padding: 20, animation: "scaleIn 0.4s ease" }}>
                        <div style={{ width: 64, height: 64, borderRadius: "50%", background: "var(--accent-light)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 30, color: "var(--accent)", animation: "checkPop 0.5s ease 0.2s both" }}>&#10003;</div>
                        <h3 style={{ fontFamily: "'Lora', serif", fontSize: 22, fontWeight: 700, color: "var(--accent)", marginBottom: 8 }}>Basvurunuz Alindi!</h3>
                        <p style={{ color: "var(--text3)", fontSize: 14, marginBottom: 16 }}>Yonetim ekibimiz inceledikten sonra giris yapabileceksiniz.</p>
                        <button className="btn btn-accent" onClick={() => { setFormSubmitted(false); setDoctorAuthMode("login"); }} style={{ padding: "10px 24px" }}>Giris Sayfasina Don</button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              /* Doktor Dashboard */
              <>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 28 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                    <div style={{
                      width: 56, height: 56, borderRadius: 16,
                      background: `linear-gradient(135deg, ${doctorAccount?.color || "var(--accent)"}20, ${doctorAccount?.color || "var(--accent)"}08)`,
                      border: `2px solid ${doctorAccount?.color || "var(--accent)"}30`,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 20, fontWeight: 700, color: doctorAccount?.color || "var(--accent)"
                    }}>{doctorAccount?.avatar}</div>
                    <div>
                      <h2 style={{ fontFamily: "'Lora', serif", fontSize: 24, fontWeight: 700 }}>Hosgeldiniz, {doctorAccount?.name}</h2>
                      <p style={{ color: "var(--accent)", fontSize: 14 }}>{doctorAccount?.specialty} · {doctorAccount?.hospital}</p>
                    </div>
                  </div>
                  <button className="btn btn-ghost" onClick={() => { setDoctorLoggedIn(false); setDoctorAccount(null); setPage("home"); }}>Cikis Yap</button>
                </div>

                {/* Stats */}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14, marginBottom: 28 }}>
                  {[
                    { label: "Toplam Randevu", value: appointments.filter(a => a.doctorId === doctorAccount?.id).length, color: "var(--accent)", bg: "var(--accent-light)", icon: "&#128197;" },
                    { label: "Onaylanmis", value: appointments.filter(a => a.doctorId === doctorAccount?.id && a.status === "confirmed").length, color: "#27ae60", bg: "#e8f8f0", icon: "&#9989;" },
                    { label: "Beklemede", value: appointments.filter(a => a.doctorId === doctorAccount?.id && a.status === "pending").length, color: "#f39c12", bg: "#fef9e7", icon: "&#9203;" },
                    { label: "Puan", value: doctorAccount?.rating || "0", color: "#e67e22", bg: "#fef3e2", icon: "&#11088;" },
                  ].map((s, i) => (
                    <div key={i} style={{ background: s.bg, border: `1px solid ${s.color}20`, borderRadius: 16, padding: 20, textAlign: "center" }}>
                      <div style={{ fontSize: 22, marginBottom: 2 }} dangerouslySetInnerHTML={{ __html: s.icon }} />
                      <div style={{ fontSize: 26, fontWeight: 700, color: s.color }}>{s.value}</div>
                      <div style={{ fontSize: 12, color: s.color, fontWeight: 500 }}>{s.label}</div>
                    </div>
                  ))}
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
                  {/* Sol - Musaitlik Yonetimi */}
                  <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 20, padding: 28 }}>
                    <h3 style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 600, marginBottom: 20 }}>&#128197; Musaitlik Durumu</h3>
                    <p style={{ fontSize: 13, color: "var(--text3)", marginBottom: 16 }}>Musait oldugunuz gun ve saatleri secin</p>

                    <div style={{ marginBottom: 18 }}>
                      <label style={{ fontSize: 13, fontWeight: 600, color: "var(--text2)", display: "block", marginBottom: 10 }}>Gun Secin</label>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                        {DATES.filter(d => !d.isWeekend).map((d, i) => {
                          const key = `${doctorAccount?.id}-${i}`;
                          const isActive = doctorAvailSlots[key];
                          return (
                            <button key={i} onClick={() => setDoctorAvailSlots(prev => ({ ...prev, [key]: !prev[key] }))}
                              style={{
                                padding: "8px 14px", borderRadius: 10,
                                border: `1.5px solid ${isActive ? "var(--accent)" : "var(--border)"}`,
                                background: isActive ? "var(--accent)" : "var(--card)",
                                color: isActive ? "#fff" : "var(--text2)",
                                fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "'Outfit', sans-serif"
                              }}>
                              {d.dayName} {d.day}
                            </button>
                          );
                        })}
                      </div>
                    </div>

                    <div style={{ marginBottom: 18 }}>
                      <label style={{ fontSize: 13, fontWeight: 600, color: "var(--text2)", display: "block", marginBottom: 10 }}>Saat Araligi</label>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 6 }}>
                        {TIME_SLOTS.map(s => {
                          const key = `${doctorAccount?.id}-time-${s.time}`;
                          const isActive = doctorAvailSlots[key];
                          return (
                            <button key={s.time} onClick={() => setDoctorAvailSlots(prev => ({ ...prev, [key]: !prev[key] }))}
                              style={{
                                padding: "8px", borderRadius: 8,
                                border: `1.5px solid ${isActive ? "var(--accent)" : "var(--border)"}`,
                                background: isActive ? "var(--accent-light)" : "var(--card)",
                                color: isActive ? "var(--accent)" : "var(--text3)",
                                fontSize: 12, fontWeight: 500, cursor: "pointer", fontFamily: "'Outfit', sans-serif"
                              }}>
                              {s.time}
                            </button>
                          );
                        })}
                      </div>
                    </div>

                    <button className="btn btn-accent" style={{ width: "100%", padding: 12, fontSize: 13 }}
                      onClick={() => {
                        setDoctors(prev => prev.map(d => d.id === doctorAccount?.id ? { ...d, availableToday: true, nextSlot: "Guncellendi" } : d));
                        alert("Musaitlik durumunuz guncellendi!");
                      }}>
                      &#10003; Musaitligi Kaydet
                    </button>
                  </div>

                  {/* Sag - Randevularim */}
                  <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 20, padding: 28 }}>
                    <h3 style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 600, marginBottom: 20 }}>&#128203; Randevularim</h3>
                    {(() => {
                      const myAppts = appointments.filter(a => a.doctorId === doctorAccount?.id);
                      if (myAppts.length === 0) return (
                        <div style={{ textAlign: "center", padding: 30 }}>
                          <div style={{ fontSize: 40, marginBottom: 10 }}>&#128197;</div>
                          <p style={{ color: "var(--text3)", fontSize: 14 }}>Henuz randevunuz yok</p>
                        </div>
                      );
                      return (
                        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                          {myAppts.map(a => (
                            <div key={a.id} style={{
                              border: "1px solid var(--border)", borderRadius: 14, padding: 16,
                              borderLeft: `3px solid ${a.status === "confirmed" ? "#27ae60" : a.status === "pending" ? "#f39c12" : "var(--red)"}`
                            }}>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                                <span style={{ fontSize: 14, fontWeight: 600 }}>{a.patient}</span>
                                <span className={`status-badge ${a.status === "confirmed" ? "status-approved" : a.status === "pending" ? "status-pending" : "status-rejected"}`} style={{ fontSize: 11 }}>
                                  {a.status === "confirmed" ? "&#10003; Onaylandi" : a.status === "pending" ? "&#9203; Beklemede" : "&#10005; Iptal"}
                                </span>
                              </div>
                              <div style={{ display: "flex", gap: 14, fontSize: 12, color: "var(--text3)", marginBottom: 6 }}>
                                <span>&#128197; {a.date}</span>
                                <span>&#128336; {a.time}</span>
                                <span>&#8378;{a.price}</span>
                                <span>{a.type === "online" ? "&#128187; Online" : "&#127973; Yuz Yuze"}</span>
                              </div>
                              {a.note && <p style={{ fontSize: 12, color: "var(--text2)", background: "var(--bg)", borderRadius: 8, padding: 8, marginBottom: 6 }}>{a.note}</p>}
                              <div style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
                                {a.status === "pending" && (
                                  <button className="btn btn-accent" style={{ padding: "6px 14px", fontSize: 11 }} onClick={() => updateApptStatus(a.id, "confirmed")}>Onayla</button>
                                )}
                                {a.type === "online" && a.status === "confirmed" && a.meetLink && (
                                  <a href={a.meetLink} target="_blank" rel="noopener noreferrer"
                                    className="btn btn-accent" style={{ padding: "6px 14px", fontSize: 11, textDecoration: "none", background: "#2980b9" }}>
                                    &#128187; Gorusmeyi Baslat
                                  </a>
                                )}
                                {a.status !== "cancelled" && (
                                  <button className="btn btn-ghost" style={{ padding: "6px 14px", fontSize: 11 }} onClick={() => updateApptStatus(a.id, "cancelled")}>Iptal Et</button>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      );
                    })()}
                  </div>
                </div>

                {/* Profil Bilgileri */}
                <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 20, padding: 28, marginTop: 24 }}>
                  <h3 style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 600, marginBottom: 16 }}>&#128100; Profil Bilgileri</h3>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16 }}>
                    {[
                      { l: "Ad Soyad", v: doctorAccount?.name },
                      { l: "Unvan", v: doctorAccount?.title },
                      { l: "Uzmanlik", v: doctorAccount?.specialty },
                      { l: "Hastane", v: doctorAccount?.hospital },
                      { l: "Sehir", v: `${doctorAccount?.city}${doctorAccount?.district ? ", " + doctorAccount.district : ""}` },
                      { l: "Tecrube", v: `${doctorAccount?.experience} Yil` },
                      { l: "Ucret", v: `\u20BA${doctorAccount?.price}` },
                      { l: "Puan", v: `${doctorAccount?.rating} (${doctorAccount?.reviews} yorum)` },
                    ].map((item, i) => (
                      <div key={i} style={{ padding: "10px 0" }}>
                        <div style={{ fontSize: 11, color: "var(--text3)", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>{item.l}</div>
                        <div style={{ fontSize: 14, fontWeight: 600, color: "var(--text)" }}>{item.v}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {/* ==================== ADMIN PANEL ==================== */}
        {page === "admin" && (
          <div style={{ maxWidth: 1000, margin: "0 auto", padding: "40px 28px", animation: "fadeUp 0.4s ease" }}>
            <button className="btn btn-ghost" onClick={goHome} style={{ marginBottom: 24, fontSize: 13, padding: "8px 16px" }}>
              &#8592; Ana Sayfaya Don
            </button>

            {!adminLoggedIn ? (
              /* Admin Login */
              <div style={{ maxWidth: 420, margin: "0 auto", background: "var(--card)", border: "1px solid var(--border)", borderRadius: 24, padding: 40, textAlign: "center" }}>
                <div style={{
                  width: 56, height: 56, borderRadius: 16, margin: "0 auto 20px",
                  background: "linear-gradient(135deg, #34495e, #2c3e50)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 24, color: "#fff"
                }}>&#128274;</div>
                <h2 style={{ fontFamily: "'Lora', serif", fontSize: 24, fontWeight: 700, marginBottom: 8 }}>Yonetim Paneli</h2>
                <p style={{ color: "var(--text3)", fontSize: 14, marginBottom: 28 }}>Devam etmek icin yonetici sifresini girin</p>
                <input className="field" type="password" placeholder="Yonetici sifresi" value={adminPass}
                  onChange={e => setAdminPass(e.target.value)} style={{ marginBottom: 16, textAlign: "center" }}
                  onKeyDown={e => e.key === "Enter" && adminPass === "admin123" && setAdminLoggedIn(true)} />
                <button className="btn btn-accent" style={{ width: "100%", padding: 14 }}
                  onClick={() => { if (adminPass === "admin123") setAdminLoggedIn(true); else alert("Yanlis sifre!"); }}>
                  Giris Yap
                </button>
                <p style={{ fontSize: 12, color: "var(--text3)", marginTop: 16 }}>Demo sifre: admin123</p>
              </div>
            ) : (
              /* Admin Dashboard */
              <>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 28 }}>
                  <div>
                    <h2 style={{ fontFamily: "'Lora', serif", fontSize: 28, fontWeight: 700 }}>Yonetim Paneli</h2>
                    <p style={{ color: "var(--text3)", fontSize: 14 }}>Doktor basvurularini yonetin</p>
                  </div>
                  <button className="btn btn-ghost" onClick={() => { setAdminLoggedIn(false); setPage("home"); }}>Cikis Yap</button>
                </div>

                {/* Stats */}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 32 }}>
                  {[
                    { label: "Toplam Doktor", value: doctors.length, color: "var(--accent)", bg: "var(--accent-light)" },
                    { label: "Onaylanmis", value: approvedDoctors.length, color: "#27ae60", bg: "#e8f8f0" },
                    { label: "Beklemede", value: pendingDoctors.length, color: "#f39c12", bg: "#fef9e7" },
                    { label: "Reddedilen", value: doctors.filter(d => d.status === "rejected").length, color: "var(--red)", bg: "#fdedec" },
                  ].map((s, i) => (
                    <div key={i} style={{ background: s.bg, border: `1px solid ${s.color}20`, borderRadius: 16, padding: 22, textAlign: "center" }}>
                      <div style={{ fontSize: 32, fontWeight: 700, color: s.color }}>{s.value}</div>
                      <div style={{ fontSize: 13, color: s.color, fontWeight: 500, marginTop: 4 }}>{s.label}</div>
                    </div>
                  ))}
                </div>

                {/* Bekleyen Basvurular */}
                <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 20, padding: 28, marginBottom: 28 }}>
                  <h3 style={{ fontFamily: "'Lora', serif", fontSize: 20, fontWeight: 600, marginBottom: 20, display: "flex", alignItems: "center", gap: 10 }}>
                    Bekleyen Basvurular
                    {pendingDoctors.length > 0 && (
                      <span style={{ background: "#f39c12", color: "#fff", fontSize: 12, fontWeight: 700, padding: "3px 10px", borderRadius: 20 }}>{pendingDoctors.length}</span>
                    )}
                  </h3>

                  {pendingDoctors.length === 0 ? (
                    <div style={{ textAlign: "center", padding: 40 }}>
                      <div style={{ fontSize: 48, marginBottom: 12 }}>&#9989;</div>
                      <p style={{ color: "var(--text3)", fontSize: 15 }}>Bekleyen basvuru bulunmuyor</p>
                    </div>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                      {pendingDoctors.map((d, i) => (
                        <div key={d.id} style={{
                          border: "1px solid var(--border)", borderRadius: 16, padding: 22,
                          background: "var(--bg)", animation: `fadeUp 0.3s ease ${i * 0.05}s both`
                        }}>
                          <div style={{ display: "flex", gap: 18, alignItems: "flex-start" }}>
                            <div style={{
                              width: 64, height: 64, borderRadius: 16, flexShrink: 0,
                              background: `linear-gradient(135deg, ${d.color}20, ${d.color}08)`,
                              border: `2px solid ${d.color}25`,
                              display: "flex", alignItems: "center", justifyContent: "center",
                              fontSize: 20, fontWeight: 700, color: d.color
                            }}>{d.avatar}</div>
                            <div style={{ flex: 1 }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                                <h4 style={{ fontFamily: "'Lora', serif", fontSize: 17, fontWeight: 600 }}>{d.name}</h4>
                                <span style={{ fontSize: 12, color: "var(--text3)" }}>{d.title}</span>
                                <span className="status-badge status-pending">&#9203; Beklemede</span>
                              </div>
                              <p style={{ fontSize: 14, color: "var(--accent)", fontWeight: 500, marginBottom: 6 }}>{d.specialty}{d.sub ? ` · ${d.sub}` : ""}</p>
                              <p style={{ fontSize: 13, color: "var(--text3)", marginBottom: 6 }}>&#127973; {d.hospital} · &#128205; {d.city}{d.district ? `, ${d.district}` : ""} · &#128197; {d.experience} yil · &#8378;{d.price}/muayene</p>
                              <p style={{ fontSize: 13, color: "var(--text2)", marginBottom: 8, lineHeight: 1.5 }}>{d.bio}</p>
                              {d.tags && d.tags.length > 0 && (
                                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
                                  {d.tags.map(t => (
                                    <span key={t} style={{ fontSize: 11, padding: "3px 10px", borderRadius: 6, background: "var(--card)", color: "var(--text2)", fontWeight: 500 }}>{t}</span>
                                  ))}
                                </div>
                              )}
                              <p style={{ fontSize: 12, color: "var(--text3)" }}>&#128222; {d.phone} · &#128231; {d.email}</p>
                              {d.appliedAt && (
                                <p style={{ fontSize: 11, color: "var(--text3)", marginTop: 4 }}>Basvuru: {new Date(d.appliedAt).toLocaleString("tr-TR")}</p>
                              )}
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: 8, flexShrink: 0 }}>
                              <button className="btn btn-accent" style={{ padding: "10px 24px", fontSize: 13 }}
                                onClick={() => approveDoctor(d.id)}>
                                &#10003; Onayla
                              </button>
                              <button className="btn btn-danger" style={{ padding: "10px 24px", fontSize: 13 }}
                                onClick={() => rejectDoctor(d.id)}>
                                &#10005; Reddet
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Onaylanmis Doktorlar */}
                <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 20, padding: 28 }}>
                  <h3 style={{ fontFamily: "'Lora', serif", fontSize: 20, fontWeight: 600, marginBottom: 20 }}>
                    Onaylanmis Doktorlar ({approvedDoctors.length})
                  </h3>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                    {approvedDoctors.map(d => (
                      <div key={d.id} style={{
                        border: "1px solid var(--border)", borderRadius: 14, padding: 16,
                        display: "flex", alignItems: "center", gap: 14
                      }}>
                        <div style={{
                          width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                          background: `linear-gradient(135deg, ${d.color}20, ${d.color}08)`,
                          display: "flex", alignItems: "center", justifyContent: "center",
                          fontSize: 14, fontWeight: 700, color: d.color
                        }}>{d.avatar}</div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 14, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{d.name}</div>
                          <div style={{ fontSize: 12, color: "var(--accent)" }}>{d.specialty}</div>
                          <div style={{ fontSize: 11, color: "var(--text3)" }}>{d.city} · &#8378;{d.price}</div>
                        </div>
                        <span className="status-badge status-approved" style={{ flexShrink: 0 }}>&#10003; Aktif</span>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {/* ==================== HASTA PANELI ==================== */}
        {page === "patient-panel" && (
          <div style={{ maxWidth: patientLoggedIn ? 1100 : 480, margin: "0 auto", padding: "40px 28px", animation: "fadeUp 0.4s ease" }}>
            <button className="btn btn-ghost" onClick={goHome} style={{ marginBottom: 24, fontSize: 13, padding: "8px 16px" }}>
              &#8592; Ana Sayfaya Don
            </button>

            {!patientLoggedIn ? (
              /* Login / Register */
              <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 24, padding: 40 }}>
                <div style={{ textAlign: "center", marginBottom: 28 }}>
                  <div style={{
                    width: 56, height: 56, borderRadius: 16, margin: "0 auto 16px",
                    background: "linear-gradient(135deg, #3498db, #2ecc71)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 24, color: "#fff"
                  }}>&#128100;</div>
                  <h2 style={{ fontFamily: "'Lora', serif", fontSize: 24, fontWeight: 700, marginBottom: 8 }}>Hasta Paneli</h2>
                  <p style={{ color: "var(--text3)", fontSize: 14 }}>Randevularinizi takip edin, saglik bilgilerinizi yonetin</p>
                </div>

                {/* Auth Tabs */}
                <div style={{ display: "flex", gap: 0, background: "var(--bg2)", borderRadius: 12, padding: 4, marginBottom: 24 }}>
                  {[{ key: "login", label: "Giris Yap" }, { key: "register", label: "Kayit Ol" }].map(t => (
                    <button key={t.key} onClick={() => setPatientAuthMode(t.key)}
                      style={{
                        flex: 1, padding: "10px", borderRadius: 8, border: "none",
                        background: patientAuthMode === t.key ? "var(--card)" : "transparent",
                        color: patientAuthMode === t.key ? "var(--accent)" : "var(--text3)",
                        fontWeight: 600, fontSize: 14, cursor: "pointer", transition: "all 0.2s",
                        boxShadow: patientAuthMode === t.key ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
                        fontFamily: "'Outfit', sans-serif"
                      }}>{t.label}</button>
                  ))}
                </div>

                {patientAuthMode === "login" ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>E-posta</label>
                      <input className="field" placeholder="ornek@mail.com" value={patientLoginForm.email}
                        onChange={e => setPatientLoginForm(f => ({ ...f, email: e.target.value }))} />
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Sifre</label>
                      <input className="field" type="password" placeholder="Sifreniz" value={patientLoginForm.password}
                        onChange={e => setPatientLoginForm(f => ({ ...f, password: e.target.value }))} />
                    </div>
                    <button className="btn btn-accent" style={{ width: "100%", padding: 14, marginTop: 8 }}
                      onClick={() => {
                        const found = registeredPatients.find(p => p.email === patientLoginForm.email && p.password === patientLoginForm.password);
                        if (found) { setPatientAccount(found); setPatientLoggedIn(true); }
                        else alert("E-posta veya sifre hatali!");
                      }}>
                      Giris Yap
                    </button>
                    <p style={{ fontSize: 12, color: "var(--text3)", textAlign: "center" }}>Demo: ahmet@mail.com / 123456</p>
                  </div>
                ) : (
                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                      <div>
                        <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Ad Soyad *</label>
                        <input className="field" placeholder="Ad Soyad" value={patientRegForm.name}
                          onChange={e => setPatientRegForm(f => ({ ...f, name: e.target.value }))} />
                      </div>
                      <div>
                        <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>TC Kimlik No</label>
                        <input className="field" placeholder="12345678901" value={patientRegForm.tc}
                          onChange={e => setPatientRegForm(f => ({ ...f, tc: e.target.value }))} />
                      </div>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                      <div>
                        <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>E-posta *</label>
                        <input className="field" placeholder="ornek@mail.com" value={patientRegForm.email}
                          onChange={e => setPatientRegForm(f => ({ ...f, email: e.target.value }))} />
                      </div>
                      <div>
                        <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Telefon *</label>
                        <input className="field" placeholder="0532 000 00 00" value={patientRegForm.phone}
                          onChange={e => setPatientRegForm(f => ({ ...f, phone: e.target.value }))} />
                      </div>
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Sifre *</label>
                      <input className="field" type="password" placeholder="En az 6 karakter" value={patientRegForm.password}
                        onChange={e => setPatientRegForm(f => ({ ...f, password: e.target.value }))} />
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14 }}>
                      <div>
                        <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Dogum Yili</label>
                        <input className="field" placeholder="1990" value={patientRegForm.birthYear}
                          onChange={e => setPatientRegForm(f => ({ ...f, birthYear: e.target.value }))} />
                      </div>
                      <div>
                        <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Cinsiyet</label>
                        <select className="field" value={patientRegForm.gender} onChange={e => setPatientRegForm(f => ({ ...f, gender: e.target.value }))}>
                          <option value="">Secin</option>
                          <option value="Erkek">Erkek</option>
                          <option value="Kadin">Kadin</option>
                        </select>
                      </div>
                      <div>
                        <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Kan Grubu</label>
                        <select className="field" value={patientRegForm.bloodType} onChange={e => setPatientRegForm(f => ({ ...f, bloodType: e.target.value }))}>
                          <option value="">Secin</option>
                          {["A Rh+", "A Rh-", "B Rh+", "B Rh-", "AB Rh+", "AB Rh-", "0 Rh+", "0 Rh-"].map(b => <option key={b} value={b}>{b}</option>)}
                        </select>
                      </div>
                    </div>
                    <div>
                      <label style={{ fontSize: 13, fontWeight: 500, color: "var(--text2)", display: "block", marginBottom: 6 }}>Sehir</label>
                      <select className="field" value={patientRegForm.city} onChange={e => setPatientRegForm(f => ({ ...f, city: e.target.value }))}>
                        <option value="">Secin</option>
                        {ALL_CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <button className="btn btn-accent" style={{ width: "100%", padding: 14, marginTop: 8 }}
                      onClick={() => {
                        const f = patientRegForm;
                        if (!f.name || !f.email || !f.phone || !f.password) { alert("Zorunlu alanlari doldurun!"); return; }
                        const newPatient = { id: `p${Date.now()}`, ...f };
                        setRegisteredPatients(prev => [...prev, newPatient]);
                        setPatientAccount(newPatient);
                        setPatientLoggedIn(true);
                        sendMail("patient-register", { email: f.email, name: f.name });
                      }}>
                      Kayit Ol
                    </button>
                  </div>
                )}
              </div>
            ) : (
              /* Patient Dashboard */
              <>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 28 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                    <div style={{
                      width: 56, height: 56, borderRadius: 16,
                      background: "linear-gradient(135deg, #3498db20, #2ecc7120)",
                      border: "2px solid #3498db30",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 20, fontWeight: 700, color: "#3498db"
                    }}>{patientAccount?.name?.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase()}</div>
                    <div>
                      <h2 style={{ fontFamily: "'Lora', serif", fontSize: 24, fontWeight: 700 }}>Hosgeldiniz, {patientAccount?.name?.split(" ")[0]}</h2>
                      <p style={{ color: "var(--text3)", fontSize: 14 }}>{patientAccount?.email}</p>
                    </div>
                  </div>
                  <button className="btn btn-ghost" onClick={() => { setPatientLoggedIn(false); setPatientAccount(null); setPage("home"); }}>Cikis Yap</button>
                </div>

                {/* Quick Stats */}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14, marginBottom: 28 }}>
                  {[
                    { label: "Randevularim", value: appointments.filter(a => a.email === patientAccount?.email || a.patient === patientAccount?.name).length, icon: "&#128197;", color: "var(--accent)", bg: "var(--accent-light)" },
                    { label: "Aktif Randevu", value: appointments.filter(a => (a.email === patientAccount?.email || a.patient === patientAccount?.name) && a.status === "confirmed").length, icon: "&#9989;", color: "#27ae60", bg: "#e8f8f0" },
                    { label: "Favori Doktor", value: favorited.size, icon: "&#10084;&#65039;", color: "#e74c3c", bg: "#fdedec" },
                  ].map((s, i) => (
                    <div key={i} style={{ background: s.bg, border: `1px solid ${s.color}20`, borderRadius: 16, padding: 22, textAlign: "center" }}>
                      <div style={{ fontSize: 28, marginBottom: 4 }} dangerouslySetInnerHTML={{ __html: s.icon }} />
                      <div style={{ fontSize: 28, fontWeight: 700, color: s.color }}>{s.value}</div>
                      <div style={{ fontSize: 13, color: s.color, fontWeight: 500 }}>{s.label}</div>
                    </div>
                  ))}
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
                  {/* Sol - Profil Bilgileri */}
                  <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 20, padding: 28 }}>
                    <h3 style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 600, marginBottom: 20, display: "flex", alignItems: "center", gap: 8 }}>
                      &#128100; Profil Bilgileri
                    </h3>
                    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                      {[
                        { label: "Ad Soyad", value: patientAccount?.name },
                        { label: "E-posta", value: patientAccount?.email },
                        { label: "Telefon", value: patientAccount?.phone },
                        { label: "TC Kimlik", value: patientAccount?.tc ? patientAccount.tc.slice(0, 3) + "****" + patientAccount.tc.slice(-2) : "-" },
                        { label: "Dogum Yili", value: patientAccount?.birthYear || "-" },
                        { label: "Cinsiyet", value: patientAccount?.gender || "-" },
                        { label: "Kan Grubu", value: patientAccount?.bloodType || "-" },
                        { label: "Sehir", value: patientAccount?.city || "-" },
                      ].map((item, i) => (
                        <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: i < 7 ? "1px solid var(--border)" : "none" }}>
                          <span style={{ fontSize: 13, color: "var(--text3)" }}>{item.label}</span>
                          <span style={{ fontSize: 13, fontWeight: 600, color: "var(--text)" }}>{item.value}</span>
                        </div>
                      ))}
                    </div>
                    <button className="btn btn-outline" style={{ width: "100%", marginTop: 20, padding: 12, fontSize: 13 }}
                      onClick={() => { goHome(); }}>
                      &#128269; Yeni Randevu Al
                    </button>
                  </div>

                  {/* Sag - Randevularim */}
                  <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 20, padding: 28 }}>
                    <h3 style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 600, marginBottom: 20, display: "flex", alignItems: "center", gap: 8 }}>
                      &#128197; Randevularim
                    </h3>
                    {(() => {
                      const myAppts = appointments.filter(a => a.email === patientAccount?.email || a.patient === patientAccount?.name);
                      if (myAppts.length === 0) return (
                        <div style={{ textAlign: "center", padding: 30 }}>
                          <div style={{ fontSize: 40, marginBottom: 10 }}>&#128197;</div>
                          <p style={{ color: "var(--text3)", fontSize: 14, marginBottom: 16 }}>Henuz randevunuz yok</p>
                          <button className="btn btn-accent" style={{ fontSize: 13, padding: "10px 20px" }} onClick={goHome}>Doktor Ara</button>
                        </div>
                      );
                      return (
                        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                          {myAppts.map(a => {
                            const doctor = approvedDoctors.find(d => d.id === a.doctorId);
                            return (
                              <div key={a.id} style={{
                                border: "1px solid var(--border)", borderRadius: 14, padding: 16,
                                borderLeft: `3px solid ${a.status === "confirmed" ? "#27ae60" : a.status === "pending" ? "#f39c12" : "var(--red)"}`
                              }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
                                  <div style={{
                                    width: 40, height: 40, borderRadius: 12, flexShrink: 0,
                                    background: doctor ? `linear-gradient(135deg, ${doctor.color}20, ${doctor.color}08)` : "var(--bg2)",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    fontSize: 14, fontWeight: 700, color: doctor ? doctor.color : "var(--text3)"
                                  }}>{doctor ? doctor.avatar : "?"}</div>
                                  <div style={{ flex: 1 }}>
                                    <div style={{ fontSize: 14, fontWeight: 600 }}>{a.doctorName}</div>
                                    <div style={{ fontSize: 12, color: "var(--accent)" }}>{a.specialty}</div>
                                  </div>
                                  <span className={`status-badge ${a.status === "confirmed" ? "status-approved" : a.status === "pending" ? "status-pending" : "status-rejected"}`} style={{ fontSize: 11 }}>
                                    {a.status === "confirmed" ? "&#10003; Onaylandi" : a.status === "pending" ? "&#9203; Beklemede" : "&#10005; Iptal"}
                                  </span>
                                </div>
                                <div style={{ display: "flex", gap: 16, fontSize: 12, color: "var(--text3)", marginBottom: 4 }}>
                                  <span>&#128197; {a.date}</span>
                                  <span>&#128336; {a.time}</span>
                                  <span>&#8378;{a.price}</span>
                                  <span>{a.type === "online" ? "&#128187; Online" : "&#127973; Yuz Yuze"}</span>
                                </div>
                                {a.type === "yuzYuze" && a.hospital && (
                                  <div style={{ fontSize: 11, color: "var(--text3)", marginBottom: 4 }}>&#128205; {a.hospital}, {a.city}{a.district ? " / " + a.district : ""}</div>
                                )}
                                <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
                                  {a.type === "online" && a.status === "confirmed" && a.meetLink && (
                                    <a href={a.meetLink} target="_blank" rel="noopener noreferrer"
                                      className="btn btn-accent" style={{ padding: "6px 14px", fontSize: 11, textDecoration: "none" }}>
                                      &#128187; Gorusmeye Katil
                                    </a>
                                  )}
                                  {a.type === "online" && a.status === "pending" && (
                                    <span style={{ fontSize: 11, color: "#856404", background: "#fff3cd", padding: "4px 10px", borderRadius: 8 }}>&#9203; Onay bekleniyor, link sonra aktif olacak</span>
                                  )}
                                  {a.status !== "cancelled" && (
                                    <button className="btn btn-ghost" style={{ padding: "6px 14px", fontSize: 11 }}
                                      onClick={() => updateApptStatus(a.id, "cancelled")}>
                                      Iptal Et
                                    </button>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {/* ==================== RANDEVU YONETIMI ==================== */}
        {page === "appointments" && (
          <div style={{ maxWidth: 1100, margin: "0 auto", padding: "40px 28px", animation: "fadeUp 0.4s ease" }}>
            <button className="btn btn-ghost" onClick={goHome} style={{ marginBottom: 24, fontSize: 13, padding: "8px 16px" }}>
              &#8592; Ana Sayfaya Don
            </button>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 28 }}>
              <div>
                <h2 style={{ fontFamily: "'Lora', serif", fontSize: 28, fontWeight: 700 }}>Randevu Yonetimi</h2>
                <p style={{ color: "var(--text3)", fontSize: 14 }}>Tum randevulari goruntuleyin ve yonetin</p>
              </div>
            </div>

            {/* Stats */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14, marginBottom: 28 }}>
              {[
                { label: "Toplam", value: appointments.length, color: "var(--accent)", bg: "var(--accent-light)", icon: "&#128203;" },
                { label: "Onaylanmis", value: appointments.filter(a => a.status === "confirmed").length, color: "#27ae60", bg: "#e8f8f0", icon: "&#9989;" },
                { label: "Beklemede", value: appointments.filter(a => a.status === "pending").length, color: "#f39c12", bg: "#fef9e7", icon: "&#9203;" },
                { label: "Iptal", value: appointments.filter(a => a.status === "cancelled").length, color: "var(--red)", bg: "#fdedec", icon: "&#10060;" },
              ].map((s, i) => (
                <div key={i} style={{ background: s.bg, border: `1px solid ${s.color}20`, borderRadius: 16, padding: 20, textAlign: "center" }}>
                  <div style={{ fontSize: 24, marginBottom: 4 }} dangerouslySetInnerHTML={{ __html: s.icon }} />
                  <div style={{ fontSize: 28, fontWeight: 700, color: s.color }}>{s.value}</div>
                  <div style={{ fontSize: 13, color: s.color, fontWeight: 500 }}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* Filter Tabs */}
            <div style={{ display: "flex", gap: 0, background: "var(--bg2)", borderRadius: 14, padding: 4, marginBottom: 24 }}>
              {[
                { key: "all", label: "Tumunu Goster" },
                { key: "confirmed", label: "Onaylanmis" },
                { key: "pending", label: "Beklemede" },
                { key: "cancelled", label: "Iptal Edilen" },
              ].map(f => (
                <button key={f.key} onClick={() => setApptFilter(f.key)}
                  style={{
                    flex: 1, padding: "10px 12px", borderRadius: 10, border: "none",
                    background: apptFilter === f.key ? "var(--card)" : "transparent",
                    color: apptFilter === f.key ? "var(--accent)" : "var(--text3)",
                    fontWeight: apptFilter === f.key ? 600 : 500, fontSize: 13,
                    cursor: "pointer", transition: "all 0.2s",
                    boxShadow: apptFilter === f.key ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
                    fontFamily: "'Outfit', sans-serif"
                  }}>
                  {f.label}
                  {f.key !== "all" && (() => {
                    const c = appointments.filter(a => a.status === f.key).length;
                    return c > 0 ? ` (${c})` : "";
                  })()}
                </button>
              ))}
            </div>

            {/* Appointment List */}
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {appointments
                .filter(a => apptFilter === "all" || a.status === apptFilter)
                .map((a, i) => {
                  const doctor = approvedDoctors.find(d => d.id === a.doctorId);
                  return (
                    <div key={a.id} style={{
                      background: "var(--card)", border: "1px solid var(--border)", borderRadius: 18,
                      padding: 24, animation: `fadeUp 0.3s ease ${i * 0.04}s both`,
                      borderLeft: `4px solid ${a.status === "confirmed" ? "#27ae60" : a.status === "pending" ? "#f39c12" : "var(--red)"}`
                    }}>
                      <div style={{ display: "flex", gap: 20, alignItems: "flex-start" }}>
                        {/* Doctor Avatar */}
                        <div style={{
                          width: 56, height: 56, borderRadius: 16, flexShrink: 0,
                          background: doctor ? `linear-gradient(135deg, ${doctor.color}20, ${doctor.color}08)` : "var(--bg2)",
                          border: doctor ? `2px solid ${doctor.color}25` : "2px solid var(--border)",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          fontSize: 18, fontWeight: 700, color: doctor ? doctor.color : "var(--text3)"
                        }}>{doctor ? doctor.avatar : "?"}</div>

                        {/* Info */}
                        <div style={{ flex: 1 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
                            <h4 style={{ fontFamily: "'Lora', serif", fontSize: 17, fontWeight: 600 }}>{a.doctorName}</h4>
                            <span style={{ fontSize: 12, color: "var(--accent)", fontWeight: 500 }}>{a.specialty}</span>
                            <span className={`status-badge ${a.status === "confirmed" ? "status-approved" : a.status === "pending" ? "status-pending" : "status-rejected"}`}>
                              {a.status === "confirmed" ? "&#10003; Onaylandi" : a.status === "pending" ? "&#9203; Beklemede" : "&#10005; Iptal"}
                            </span>
                          </div>
                          <div style={{ display: "flex", gap: 24, marginBottom: 8, flexWrap: "wrap" }}>
                            <span style={{ fontSize: 13, color: "var(--text2)", display: "flex", alignItems: "center", gap: 6 }}>
                              &#128197; {a.date}
                            </span>
                            <span style={{ fontSize: 13, color: "var(--text2)", display: "flex", alignItems: "center", gap: 6 }}>
                              &#128336; {a.time}
                            </span>
                            <span style={{ fontSize: 13, color: "var(--text2)", display: "flex", alignItems: "center", gap: 6 }}>
                              &#128176; &#8378;{a.price}
                            </span>
                          </div>
                          <div style={{ background: "var(--bg)", borderRadius: 12, padding: 14, marginBottom: 8 }}>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                              <div>
                                <div style={{ fontSize: 11, color: "var(--text3)", fontWeight: 600, marginBottom: 2, textTransform: "uppercase", letterSpacing: 0.5 }}>Hasta</div>
                                <div style={{ fontSize: 14, fontWeight: 600, color: "var(--text)" }}>{a.patient}</div>
                              </div>
                              <div>
                                <div style={{ fontSize: 11, color: "var(--text3)", fontWeight: 600, marginBottom: 2, textTransform: "uppercase", letterSpacing: 0.5 }}>Telefon</div>
                                <div style={{ fontSize: 14, color: "var(--text)" }}>{a.phone}</div>
                              </div>
                              <div>
                                <div style={{ fontSize: 11, color: "var(--text3)", fontWeight: 600, marginBottom: 2, textTransform: "uppercase", letterSpacing: 0.5 }}>E-posta</div>
                                <div style={{ fontSize: 14, color: "var(--text)" }}>{a.email || "-"}</div>
                              </div>
                            </div>
                            {a.note && (
                              <div style={{ marginTop: 10, paddingTop: 10, borderTop: "1px solid var(--border)" }}>
                                <div style={{ fontSize: 11, color: "var(--text3)", fontWeight: 600, marginBottom: 2, textTransform: "uppercase", letterSpacing: 0.5 }}>Not</div>
                                <div style={{ fontSize: 13, color: "var(--text2)" }}>{a.note}</div>
                              </div>
                            )}
                          </div>
                          <div style={{ fontSize: 11, color: "var(--text3)" }}>
                            Olusturulma: {new Date(a.createdAt).toLocaleString("tr-TR")}
                          </div>
                        </div>

                        {/* Actions */}
                        <div style={{ display: "flex", flexDirection: "column", gap: 8, flexShrink: 0 }}>
                          {a.status === "pending" && (
                            <button className="btn btn-accent" style={{ padding: "8px 18px", fontSize: 12 }}
                              onClick={() => updateApptStatus(a.id, "confirmed")}>
                              &#10003; Onayla
                            </button>
                          )}
                          {a.status !== "cancelled" && (
                            <button className="btn btn-danger" style={{ padding: "8px 18px", fontSize: 12 }}
                              onClick={() => updateApptStatus(a.id, "cancelled")}>
                              &#10005; Iptal Et
                            </button>
                          )}
                          {a.status === "cancelled" && (
                            <button className="btn btn-outline" style={{ padding: "8px 18px", fontSize: 12 }}
                              onClick={() => updateApptStatus(a.id, "confirmed")}>
                              &#8635; Yeniden Aktiflestir
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}

              {appointments.filter(a => apptFilter === "all" || a.status === apptFilter).length === 0 && (
                <div style={{ textAlign: "center", padding: 60, background: "var(--card)", borderRadius: 18, border: "1px solid var(--border)" }}>
                  <div style={{ fontSize: 48, marginBottom: 12 }}>&#128197;</div>
                  <h3 style={{ fontFamily: "'Lora', serif", fontSize: 20, marginBottom: 8 }}>Randevu bulunamadi</h3>
                  <p style={{ color: "var(--text3)" }}>Bu filtreye uygun randevu yok</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* ==================== BLOG SAYFASI ==================== */}
        {page === "blog" && (
          <div style={{ maxWidth: 1100, margin: "0 auto", padding: "40px 28px", animation: "fadeUp 0.4s ease" }}>
            <button className="btn btn-ghost" onClick={() => { if (selectedPost) setSelectedPost(null); else goHome(); }} style={{ marginBottom: 24, fontSize: 13, padding: "8px 16px" }}>
              &#8592; {selectedPost ? "Yazilara Don" : "Ana Sayfaya Don"}
            </button>

            {selectedPost ? (
              /* Blog Post Detail */
              <div style={{ maxWidth: 760, margin: "0 auto" }}>
                <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 24, padding: 40 }}>
                  <span style={{ fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 8, background: "var(--accent-light)", color: "var(--accent)", marginBottom: 16, display: "inline-block" }}>
                    {selectedPost.category}
                  </span>
                  <h1 style={{ fontFamily: "'Lora', serif", fontSize: 30, fontWeight: 700, lineHeight: 1.3, marginBottom: 16 }}>{selectedPost.title}</h1>
                  <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 28, paddingBottom: 20, borderBottom: "1px solid var(--border)" }}>
                    {(() => { const doc = approvedDoctors.find(d => d.id === selectedPost.authorId); return doc ? (
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div style={{ width: 40, height: 40, borderRadius: 12, background: `linear-gradient(135deg, ${doc.color}20, ${doc.color}08)`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, color: doc.color }}>{doc.avatar}</div>
                        <div>
                          <div style={{ fontSize: 14, fontWeight: 600 }}>{selectedPost.author}</div>
                          <div style={{ fontSize: 12, color: "var(--accent)" }}>{selectedPost.specialty}</div>
                        </div>
                      </div>
                    ) : null; })()}
                    <span style={{ fontSize: 13, color: "var(--text3)" }}>{new Date(selectedPost.date).toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" })}</span>
                  </div>
                  <div style={{ background: "var(--accent-light)", borderRadius: 14, padding: 20, marginBottom: 24 }}>
                    <p style={{ fontSize: 15, color: "var(--accent)", lineHeight: 1.7, fontWeight: 500 }}>{selectedPost.summary}</p>
                  </div>
                  <p style={{ fontSize: 15, color: "var(--text2)", lineHeight: 1.8 }}>{selectedPost.content}</p>
                  <div style={{ marginTop: 32, paddingTop: 20, borderTop: "1px solid var(--border)", display: "flex", gap: 10 }}>
                    <button className="btn btn-outline" style={{ fontSize: 13, padding: "10px 20px" }}
                      onClick={() => { const doc = approvedDoctors.find(d => d.id === selectedPost.authorId); if (doc) { setSelectedDoctor(doc); setPage("detail"); setSelDate(0); setSelTime(null); setBookingStep(0); setBookingDone(false); } }}>
                      &#128197; Bu Doktordan Randevu Al
                    </button>
                    <button className="btn btn-ghost" style={{ fontSize: 13, padding: "10px 20px" }} onClick={() => setSelectedPost(null)}>
                      &#8592; Diger Yazilar
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              /* Blog List */
              <>
                <div style={{ textAlign: "center", marginBottom: 32 }}>
                  <h2 style={{ fontFamily: "'Lora', serif", fontSize: 34, fontWeight: 700, marginBottom: 10 }}>
                    Saglik <span style={{ color: "var(--accent)" }}>Blogu</span>
                  </h2>
                  <p style={{ color: "var(--text3)", fontSize: 16, maxWidth: 500, margin: "0 auto" }}>
                    Doktorlarimizin kaleminden guncel saglik yazilari ve bilgilendirici icerikler
                  </p>
                </div>

                {/* Category Filter */}
                <div style={{ display: "flex", gap: 8, justifyContent: "center", marginBottom: 28, flexWrap: "wrap" }}>
                  {["all", ...new Set(blogPosts.map(p => p.category))].map(cat => (
                    <button key={cat} className="chip" onClick={() => setBlogCategory(cat)}
                      style={blogCategory === cat ? { borderColor: "var(--accent)", color: "var(--accent)", background: "var(--accent-light)" } : {}}>
                      {cat === "all" ? "Tum Yazilar" : cat}
                    </button>
                  ))}
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 20 }}>
                  {blogPosts.filter(p => blogCategory === "all" || p.category === blogCategory).map((post, i) => {
                    const doc = approvedDoctors.find(d => d.id === post.authorId);
                    const catColors = { "Mevsimsel": "#3498db", "Beslenme": "#2ecc71", "Çocuk Sağlığı": "#e74c3c", "Nöroloji": "#9b59b6", "Dermatoloji": "#e67e22", "Kardiyoloji": "#c0392b" };
                    return (
                      <div key={post.id} onClick={() => setSelectedPost(post)}
                        style={{
                          background: "var(--card)", border: "1px solid var(--border)", borderRadius: 18,
                          padding: 26, cursor: "pointer", transition: "all 0.3s cubic-bezier(.4,0,.2,1)",
                          animation: `fadeUp 0.4s ease ${i * 0.06}s both`
                        }}
                        onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 40px rgba(44,37,32,0.1)"; e.currentTarget.style.borderColor = "var(--accent)"; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.borderColor = "var(--border)"; }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
                          <span style={{ fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 6, background: `${catColors[post.category] || "var(--accent)"}15`, color: catColors[post.category] || "var(--accent)" }}>
                            {post.category}
                          </span>
                          <span style={{ fontSize: 12, color: "var(--text3)" }}>{new Date(post.date).toLocaleDateString("tr-TR", { day: "numeric", month: "short", year: "numeric" })}</span>
                        </div>
                        <h3 style={{ fontFamily: "'Lora', serif", fontSize: 19, fontWeight: 600, marginBottom: 10, lineHeight: 1.4 }}>{post.title}</h3>
                        <p style={{ fontSize: 14, color: "var(--text3)", lineHeight: 1.6, marginBottom: 18 }}>{post.summary}</p>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          {doc && (
                            <div style={{
                              width: 32, height: 32, borderRadius: 10,
                              background: `linear-gradient(135deg, ${doc.color}20, ${doc.color}08)`,
                              display: "flex", alignItems: "center", justifyContent: "center",
                              fontSize: 11, fontWeight: 700, color: doc.color
                            }}>{doc.avatar}</div>
                          )}
                          <div>
                            <div style={{ fontSize: 13, fontWeight: 600 }}>{post.author}</div>
                            <div style={{ fontSize: 11, color: "var(--accent)" }}>{post.specialty}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        )}

        {/* ==================== UZMANLIKLAR SAYFASI ==================== */}
        {page === "specialties" && (
          <div style={{ maxWidth: 1200, margin: "0 auto", padding: "40px 28px", animation: "fadeUp 0.4s ease" }}>
            <button className="btn btn-ghost" onClick={goHome} style={{ marginBottom: 24, fontSize: 13, padding: "8px 16px" }}>
              &#8592; Ana Sayfaya Don
            </button>

            <div style={{ textAlign: "center", marginBottom: 40 }}>
              <h2 style={{ fontFamily: "'Lora', serif", fontSize: 34, fontWeight: 700, marginBottom: 10 }}>
                Uzmanlik <span style={{ color: "var(--accent)" }}>Alanlari</span>
              </h2>
              <p style={{ color: "var(--text3)", fontSize: 16, maxWidth: 560, margin: "0 auto" }}>
                Aradiginiz uzmanlik alanini secin, o branstaki tum doktorlari gorun.
              </p>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16 }}>
              {[
                { name: "Kardiyoloji", icon: "\u2764\uFE0F", desc: "Kalp ve damar hastaliklari" },
                { name: "Nöroloji", icon: "\uD83E\uDDE0", desc: "Beyin ve sinir sistemi" },
                { name: "Pediatri", icon: "\uD83D\uDC76", desc: "Cocuk sagligi ve hastaliklari" },
                { name: "Ortopedi", icon: "\uD83E\uDDB4", desc: "Kemik ve eklem cerrahisi" },
                { name: "Dermatoloji", icon: "\uD83E\uDE7A", desc: "Cilt hastaliklari ve estetik" },
                { name: "Göz Hastalıkları", icon: "\uD83D\uDC41\uFE0F", desc: "Goz sagligi ve cerrahisi" },
                { name: "Psikiyatri", icon: "\uD83E\uDDE0", desc: "Ruh sagligi ve terapi" },
                { name: "Dahiliye", icon: "\uD83E\uDE7A", desc: "Ic hastaliklari ve metabolizma" },
                { name: "Kadın Doğum", icon: "\uD83E\uDD30", desc: "Jinekoloji ve obstetrik" },
                { name: "Üroloji", icon: "\uD83C\uDFE5", desc: "Uriner sistem hastaliklari" },
                { name: "Genel Cerrahi", icon: "\uD83E\uDE78", desc: "Genel cerrahi operasyonlari" },
                { name: "KBB", icon: "\uD83D\uDC42", desc: "Kulak burun bogaz" },
                { name: "Göğüs Hastalıkları", icon: "\uD83E\uDEC1", desc: "Akciger ve solunum yolu" },
                { name: "Endokrinoloji", icon: "\uD83E\uDDEA", desc: "Hormon ve metabolizma" },
                { name: "Fizik Tedavi", icon: "\uD83C\uDFC3", desc: "Rehabilitasyon ve fizik tedavi" },
                { name: "Beyin Cerrahisi", icon: "\uD83E\uDDE0", desc: "Beyin ve omurilik cerrahisi" },
                { name: "Plastik Cerrahi", icon: "\u2728", desc: "Estetik ve rekonstruktif cerrahi" },
                { name: "Onkoloji", icon: "\uD83C\uDFE5", desc: "Kanser tedavisi ve takibi" },
                { name: "Gastroenteroloji", icon: "\uD83E\uDDB7", desc: "Sindirim sistemi hastaliklari" },
                { name: "Hematoloji", icon: "\uD83E\uDE78", desc: "Kan hastaliklari ve tedavisi" },
              ].map((spec, i) => {
                const count = approvedDoctors.filter(d => d.specialty === spec.name).length;
                return (
                  <div key={spec.name} onClick={() => { setSelBranch(spec.name); setSelSpecialty(""); setPage("home"); }}
                    style={{
                      background: "var(--card)", border: "1px solid var(--border)", borderRadius: 18,
                      padding: 24, cursor: "pointer", transition: "all 0.3s cubic-bezier(.4,0,.2,1)",
                      textAlign: "center", animation: `fadeUp 0.4s ease ${i * 0.03}s both`,
                      position: "relative", overflow: "hidden"
                    }}
                    onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 40px rgba(44,37,32,0.1)"; e.currentTarget.style.borderColor = "var(--accent)"; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.borderColor = "var(--border)"; }}>
                    <div style={{ fontSize: 36, marginBottom: 12 }}>{spec.icon}</div>
                    <h4 style={{ fontFamily: "'Lora', serif", fontSize: 16, fontWeight: 600, marginBottom: 4, color: "var(--text)" }}>{spec.name}</h4>
                    <p style={{ fontSize: 12, color: "var(--text3)", marginBottom: 10, lineHeight: 1.4 }}>{spec.desc}</p>
                    <span style={{
                      display: "inline-block", padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600,
                      background: count > 0 ? "var(--accent-light)" : "var(--bg2)",
                      color: count > 0 ? "var(--accent)" : "var(--text3)"
                    }}>
                      {count} doktor
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Footer */}
        <footer style={{
          background: "var(--card)", borderTop: "1px solid var(--border)",
          padding: "40px 28px", marginTop: 60
        }}>
          <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", gap: 40 }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                <div style={{ width: 30, height: 30, borderRadius: 8, background: "linear-gradient(135deg, var(--accent), #2ecc71)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 14, fontWeight: 700 }}>&#9877;</div>
                <span style={{ fontFamily: "'Lora', serif", fontSize: 18, fontWeight: 700 }}>SaglikBul</span>
              </div>
              <p style={{ fontSize: 13, color: "var(--text3)", lineHeight: 1.7, maxWidth: 280 }}>
                Turkiye'nin guvenilir doktor bulma ve online randevu platformu. Sagliginiz bizim onceligimiz.
              </p>
            </div>
            {[
              { title: "Platform", links: ["Doktor Ara", "Uzmanliklar", "Sehirler", "Nasil Calisir?"] },
              { title: "Doktorlar", links: ["Uye Ol", "Doktor Paneli", "Randevu Yonetimi", "Istatistikler"] },
              { title: "Destek", links: ["SSS", "Iletisim", "Gizlilik Politikasi", "Kullanim Sartlari"] },
            ].map((col, i) => (
              <div key={i}>
                <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 14, color: "var(--text)" }}>{col.title}</h4>
                {col.links.map(link => (
                  <div key={link} style={{ fontSize: 13, color: "var(--text3)", padding: "5px 0", cursor: "pointer", transition: "color 0.2s" }}
                    onMouseEnter={e => e.target.style.color = "var(--accent)"} onMouseLeave={e => e.target.style.color = "var(--text3)"}>
                    {link}
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div style={{ maxWidth: 1200, margin: "28px auto 0", paddingTop: 20, borderTop: "1px solid var(--border)", textAlign: "center", fontSize: 12, color: "var(--text3)" }}>
            &copy; 2026 SaglikBul. Tum haklari saklidir.
          </div>
        </footer>
      </div>
    </>
  );
}
